<style lang="stylus" scoped>
    .aiset-wrapper
        position absolute;
        z-index: 3;
        width 360px;
        border: 1px solid var(--border-color-gray2)
        border-radius 8px;
        box-sizing border-box;
        transform: scale(1);
        background var(--bg-color-tertiary);
        box-shadow: var(--box-shadow-color-ai-set-wrapper);
        user-select text;
        &.show {
            animation: show 0.25s ease-in-out ;
        }
        &.unshow {
            animation: unshow 0.25s ease-in-out ;
        }
        .panel-view-topbar
            background var(--bg-color-side-view)
            border-top-right-radius 8px;
            border-top-left-radius 8px;
            background-image url('../../../../assets/img/ai4/topbarbg.png')
            background-repeat no-repeat
            background-size cover;
            &.hide-bg
                background none;
            .topbar
                display flex
                justify-content space-between
                align-items center
                height 40px;
                border: none;
                padding: 0 8px 0 16px
                .panel-view-title
                    font-size 13px
                    padding-left 14px
                    max-width 200px
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                    color var(--text-color-primary)
                .panel-view-btn
                    display flex
                    align-items center
                    >svg
                        width 20px
                        height 20px
                        margin-left 16px
                        cursor pointer
                .panel-view-aititle
                    display flex
                    align-items center
                    >img
                        margin-right 4px
                    >p
                        font-size 14px
                        font-weight 700
                        color: var(--text-color-primary);
                        margin-right 4px
                    img
                        display block
                .panel-view-rightbox
                    display flex
                    align-items center
                    .panel-view-pointbox
                        position relative
                        display flex
                        align-items center
                        height 24px
                        // padding-left 4px
                        padding-right 2px
                        border-radius 4px
                        // background #F2F2F7
                        border: 1px solid var(--border-color-box-8)
                        background var(--bg-color-tertiary);
                        .point-icon
                            width 24px
                            height 24px
                            color var(--svg-color-primary)
                        .point-num
                            font-size 12px
                            line-height 16px
                            color var(--text-color-primary)
                            font-weight 400
                            min-width 40px
                            flex: 1;
                            // margin-right 4px
                        .point-btn
                            width 18px
                            height 18px
                            display flex;
                            justify-content center;
                            align-items center
                            // position absolute
                            // right 2px
                            // top 2px
                            cursor pointer
                            background: var(--bg-color-ai-point-btn);
                            border-radius 2px
                            margin-left 4px;
                            svg
                                width 16px
                                height 16px
                                color var(--svg-color-gray-42)
                            &:hover
                                background var(--themeColor)
                                svg
                                    color #fff
                    .panel-view-close
                        width 24px
                        height 24px
                        border-radius 4px
                        cursor pointer
                        margin-left 8px
                        svg
                            width 24px
                            height 24px
                            color var(--svg-color-primary)
                        &:hover
                            background var(--color-black-4)

        .aiset-box
            height: calc(100% - 40px);
            overflow hidden !important
            user-select text;
            display flex;
            flex-direction column;
            &.has-dialog
                // height: calc(100% - 56px);
                .aiset-scrollbox
                    padding-top 16px
            .aiset-scrollbox
                .bot-tcasebox
                    position relative
                    padding: 0 16px 16px 16px;
                    background-image url('../../../../assets/img/ai4/botcasebg.png')
                    background-repeat no-repeat
                    background-size cover;
                    .aiset-icon
                        height 118px;
                        display flex;
                        justify-content center;
                        align-items center
                        > div
                            display flex;
                            flex-direction column;
                            justify-content center;
                            align-items center
                            .aiset-icon-box
                                background-image url('../../../../assets/img/ai4/ai4-icon.svg')
                                width 40px;
                                height 40px;
                                margin-bottom 12px;
                                &.is-sdk
                                    background-image url('../../../../assets/img/ai4/ai4-icon-dark.svg')
                            span
                                font-size 14px;
                                font-weight 700;
                                color: var(--text-color-primary);

                    .tcasebox-box
                        margin-bottom 16px;
                        position relative
                        z-index 1
                        .tcasebox-block
                            padding 8px 0 8px 16px
                            background var(--bg-color-tertiary)
                            cursor pointer
                            border-radius 6px
                            width auto;
                            border: 1px solid var(--border-color-box-8)
                            margin-bottom 8px;
                            display flex
                            // height 40px
                            column-gap 8px
                            box-sizing border-box
                            .preset-icon
                                height 24px;
                                width 24px;
                                color: var(--svg-color-primary);
                            &:hover
                                border-color: var(--themeColor)
                            .case-desc
                                display flex;
                                align-items center
                                font-size 14px;
                                font-weight 400
                                color: var(--text-color-primary);
                                flex: 1;

                            // &:hover
                            //     border-color var(--themeColor)
                            .tcasebox-item-title
                                color #000
                                font-size 12px
                                font-weight 400
                                line-height 16px
                                margin-bottom 2px
                            .tcasebox-item-desription
                                color var(--text-color-primary)
                                font-size 11px
                                font-weight 400
                                line-height 14px
                                opacity .4
                            &:last-child
                                margin-bottom 0;
                    .try-more
                        display flex;
                        align-items center;
                        justify-content center;
                        > div
                            display flex;
                            align-items center;
                            height 24px;
                            line-height 24px;
                            // padding 0 16px 0 12px;
                            // border: 1px solid rgba(0, 0, 0, 0.08);
                            // border-radius 4px;
                            cursor pointer
                            .aiset-input-refresh
                                width 24px
                                height 24px
                                margin-right 4px
                                user-select none
                                color var(--svg-color-active)
                            span
                                color var(--themeColor)
                width 100%
                flex: 1
                // height calc(100% - 148px)
                // padding-right 16px
                padding-bottom 16px
                overflow auto
                .aimsglist
                    padding 16px;
            .aiset-input
                // min-height 172px;
                position relative
                width 100%
                padding 8px 16px 16px 16px;
                user-select none;
                .aiset-input-title
                    display flex
                    align-items center
                    column-gap 6px
                    margin-bottom 8px
                    >p
                        color var(--text-color-primary)
                        font-size 12px
                        font-weight 600
                        line-height 16px
                        letter-spacing 1.2px
                    .aiset-input-refresh
                        width 24px
                        height 24px
                        user-select none
                        cursor pointer
                        color var(--svg-color-gray-42)
                        &:hover
                            color var(--svg-color-active)
                .aiset-input-tagbox
                    position relative
                    display flex
                    flex-wrap wrap
                    column-gap 8px
                    height 24px
                    overflow hidden
                    margin-bottom 8px
                    .aiset-tagbox-item
                        display flex
                        align-items center
                        justify-content center
                        border-radius 6px
                        background rgba(1, 127, 255, 0.10)
                        padding 4px 12px
                        cursor pointer
                        user-select none
                        max-width calc(50% - 4px)
                        &:hover
                            background var(--themeColor)
                            p
                                color #fff
                        p
                            color var(--themeColor)
                            font-size 12px
                            line-height 16px
                            textOverflow()
                .aiset-input-analysetag
                    flex-wrap nowrap
                    justify-content flex-end
                    .aiset-tagbox-item
                        max-width fit-content
                        flex auto
                        width 0%

                .aiset-quit
                    position absolute
                    top -36px
                    left auto
                    right auto
                    display flex
                    justify-content center
                    width 100%
                    height 28px
                    .quit-btn
                        display flex
                        align-items center
                        column-gap 4px
                        padding 6px 8px
                        border-radius 6px
                        border 1px solid var(--border-color-box-10)
                        background var(--bg-color-ai-quit-btn)
                        cursor pointer
                        user-select none
                        &:hover
                            border-color var(--themeColor)
                        .imgblock
                            position relative
                            width 16px
                            height 16px

                            svg
                                position absolute
                                left 0
                                top 0
                                display block
                                width 16px
                                height 16px
                                color var(--themeColor)
                                &.rotate
                                    animation rotate 1.5s linear infinite
                                @keyframes rotate
                                    0%
                                        transform rotate(0)
                                    100%
                                        transform rotate(360deg)
                        p
                            color var(--themeColor)
                            font-size 12px

                .aiset-input-toolbox
                    width 100%
                    height 28px
                    margin-bottom 8px
                    display flex
                    justify-content space-between
                    align-items center
                    .left
                        display flex
                        align-items center
                        column-gap 8px
                        .left-dropdown.disabled
                            opacity .6
                            pointer-events none
                        /deep/.ivu-select-dropdown
                            padding 0;
                        .aiset-toolbox-menu
                            position relative
                            width 136px
                            height 28px
                            padding 4px 16px 4px 8px
                            border-radius 4px
                            border: 1px solid var(--border-color-box-8)
                            cursor pointer
                            user-select none
                            .down-arrow
                                position absolute
                                right 8px
                                top 8px
                                width 8px
                                height 8px
                                color var(--svg-color-primary)
                            p
                                color var(--text-color-primary)
                                font-size 12px
                                line-height 16px
                                textOverflow()
                            &.active
                                .down-arrow

                                    transform rotate(180deg)
                    .left, .right
                        .aiset-toolbox-icon
                            border-radius 6px
                            height 28px
                            width 28px
                            cursor pointer
                            &.clear-chart
                                svg
                                    fill var(--svg-color-clear-chat)
                            &.select-image-icon, &.select-file-icon
                                cursor not-allowed;
                                svg
                                    color: #a7a7a7;
                                &.can-use
                                    cursor pointer
                                    &:hover
                                        background var(--color-black-6)
                                    svg
                                        color: var(--svg-color-primary);
                                        fill: var(--svg-color-white);
                                        stroke var(--svg-color-black);
                            svg
                                height 28px
                                width 28px
                    .prompt-list-wrapper
                        width 264px;
                        padding:6px 4px 4px 6px;
                        .menu-list-wrapper
                            max-height 461px;
                            overflow-y: auto;
                        /deep/.menu-item
                            height 32px;
                            line-height 32px;
                        /deep/.menu-divide
                            width 98%
                    .ai-prompt-tips
                        width: 264px
                        height: 41px
                        top: 421px
                        padding: 0 16px
                        border-top: 1px solid var(--border-color-box-8)
                        display flex;
                        justify-content space-between;
                        align-items: center;
                        .left, .right
                            display flex;
                            align-items center
                            padding 8px 0;
                            column-gap 4px;
                            span
                                color: var(--color-black-50)
                            svg
                                margin-right 4px;
                                width 24px;
                                height 24px;
                                color var(--svg-color-black)
                                cursor pointer
                .aiset-input-area
                    position relative
                    padding 12px
                    min-height 80px
                    border-radius 6px
                    border: 1px solid var(--border-color-box-8)
                    &.active-input
                        border: 1px solid var(--themeColor)
                    &.drag-enter
                        border: 1px solid var(--themeColor)
                        background: var(--bg-color-ai-user-msg);
                        .input-expand
                            background: transparent;
                    // background linear-gradient(0deg, #F2F2F7 0%, #F2F2F7 100%), rgba(0, 0, 0, 0.04)
                    .ivu-input-wrapper
                        display block
                    /deep/ textarea
                        resize none
                        border none !important
                        outline none !important
                        box-shadow none !important
                        padding unset
                        color var(--text-color-primary)
                        font-size 12px
                        line-height 16px
                        min-height 40px!important;
                        background none
                        &::placeholder
                            color var(--text-color-primary-40)

                    .input-expand
                        margin-top 8px;
                        // position absolute
                        // width calc(100% - 24px);
                        // bottom 12px;
                        display flex
                        height 24px;
                        justify-content space-between
                        align-items center
                        background-color:var(--bg-color-tertiary);
                        .input-count
                            font-size 12px
                            line-height 16px;
                            color var(--text-color-tertiary)
                        .aiset-toolbox-sendbtn
                            // position absolute
                            // right 10px
                            // bottom 10px
                            display flex
                            flex-shrink 0
                            justify-content center
                            height 24px
                            width 24px
                            background var(--themeColor)
                            border-radius 4px
                            cursor pointer
                            user-select none
                            &:hover
                                background linear-gradient(0deg, rgba(0, 0, 0, 0.06) 0%, rgba(0, 0, 0, 0.06) 100%), var(--themeColor)
                            &.ban
                                cursor not-allowed
                                background: var(--bg-color-ai-send-btn-disabled);
                                .item-icon
                                    color var(--svg-color-ai-send-btn-disabled)
                            .item-icon
                                height 24px;
                                width 24px;
                                color: #fff
                    .upload-file-list
                        height 101px;
                        border-bottom 1px solid var(--border-color-box-8);
                        margin-bottom 12px;
                        display flex;
                        flex-direction: column
                        .img-file-wrapper
                            display flex;
                            column-gap 16px;
                            .input-file
                                border: 1px solid var(--border-color-box-8)
                                background: var(--bg-color-ai-input-file);
                                display flex;
                                align-items center;
                                justify-content center;
                                user-select none;
                                .icon-t
                                    width 100%;
                                    height 100%;
                                    display flex;
                                    align-items center;
                                    justify-content center;
                                    user-select none;
                                    img
                                        max-height 100%;
                                        max-width 100%;
                                        width auto;
                                        height auto;
                                        &.radius
                                            border-radius 6px;
                        .input-file
                            height 56px;
                            width 56px;
                            user-select none;
                            position relative;
                            // column-gap 16px;
                            margin-bottom 8px;
                            background: var(--bg-color-ai-input-file);
                            border-radius 6px;
                            display flex;
                            align-items center;
                            justify-content center;
                            user-select none;
                            &:hover
                                .closebtn
                                    display block;
                            img
                                height 40px;
                                width 40px;
                            .closebtn
                                display none
                                position absolute;
                                right -6px;
                                top -4px;
                                width 16px
                                height 16px
                                svg
                                    cursor pointer
                                    z-index 1
                                    width 16px
                                    height 16px
                                    fill: var(--svg-color-delete-file-fill);
                                    stroke: var(--svg-color-delete-file-stroke);
                        .prompt-tag
                            display flex;
                            column-gap 8px
                            user-select none;
                            .tag-item
                                padding 0 8px;
                                height 24px;
                                font-size 12px;
                                line-height 24px
                                border-radius 4px;
                                background: var(--bg-color-ai-user-msg);
                                color: var(--themeColor);
                                cursor pointer
    .test
        padding auto
    html.dark
        .aiset-wrapper
            .panel-view-topbar
                background-color var(--bg-color-tertiary)
                background-image url('../../../../assets/img/ai4/topbarbg-dark.png');
                background-size contain
                &.hide-bg
                    background none;
            .aiset-box .aiset-scrollbox .bot-tcasebox
                background-color var(--bg-color-tertiary)
                background-image url('../../../../assets/img/ai4/botcasebg-dark.png');
                background-size contain
            .aiset-box .aiset-input .aiset-input-toolbox .left
                /deep/.ivu-select-dropdown
                    border 1px solid var(--color-black-12)
    html.light
        .aiset-wrapper .aiset-box .aiset-scrollbox .bot-tcasebox .aiset-icon
            .aiset-icon-box.is-sdk
                background-image url('../../../../assets/img/ai4/ai4-icon-light.svg')

    @keyframes show {
        0% {
            right: 66px;
            height: 0;
            width: 0;
            opacity: 0;
        }

        50% {
            opacity: 0.5;
        }
        100% {
            width: 360px;
            opacity: 1;
            height: calc(100% - 157px)
        }
    }
    @keyframes unshow {
        0% {
            // width: 360px;
            height: calc(100% - 157px)
            opacity: 1;
            display: block
        }
        // 50% {
        //     opacity: 0.2;
        // }
        100% {
            opacity: 0;
            width: 0;
            height: 0;
            display none;
            right: 66px;
        }
    }
</style>

<template>
    <div class="aiset-wrapper" :style="wrapperPosition" :class="showAIPanel ? 'show' : 'unshow'">
        <div class="panel-view-topbar" :class="{ 'hide-bg': hideBg }">
            <div class="topbar">
                <div class="panel-view-aititle">
                    <p>{{ $t("aiTitle") }}</p>
                    <aiTips></aiTips>
                </div>
                <div class="panel-view-rightbox">
                    <div class="panel-view-pointbox">
                        <iconSymbol class="point-icon" name="ai-point" />
                        <p class="point-num">{{ pointNum }}</p>
                        <div
                            @click="toBuyPoint"
                            class="point-btn"
                            :content="$t('pointBuy')"
                            v-tippy="{
                                placement: 'bottom',
                            }"
                        >
                            <iconSymbol name="ai3-point-add" />
                        </div>
                    </div>
                    <div class="panel-view-close" @click="closeRightMenu()">
                        <iconSymbol name="close-right-menu" />
                    </div>
                </div>
            </div>
        </div>
        <div class="aiset-box" :class="{ 'has-dialog': hideBg }">
            <div class="aiset-scrollbox" ref="msgScrollbox" @scroll="handleScroll">
                <div class="bot-tcasebox" v-show="aiStatus === 'chat'">
                    <div class="aiset-icon">
                        <div>
                            <!-- <img v-if="EDCONFIG.IS_SDK" :key="EDCONFIG.DEFAULT_THEME" :src="require(`@/app/assets/img/ai4/ai4-icon${EDCONFIG.DEFAULT_THEME === 'dark' ? '-dark' : '-light'}.svg`)" alt="" />
                            <img v-else src="@/app/assets/img/ai4/ai4-icon.svg" alt="" /> -->
                            <div class="aiset-icon-box" :class="{ 'is-sdk': EDCONFIG.IS_SDK, 'is-light': !isDarkTheme() }"></div>
                            <span>{{ $t("aiTitle") }}</span>
                        </div>
                    </div>
                    <div class="tcasebox-box">
                        <div class="tcasebox-block" v-for="item in displayTaglist" :key="item.key" @click="handleClickPreset(item)">
                            <!-- <img :src="item.img" alt="" /> -->
                            <iconSymbol class="preset-icon" :name="item.img" />
                            <div class="case-desc">
                                {{ item.label }}
                                <!-- <p class="tcasebox-item-title">{{ $t(item.title) }}</p>
                                <p class="tcasebox-item-desription">{{ $t(item.descript) }}</p> -->
                            </div>
                        </div>
                    </div>
                    <div class="try-more">
                        <div @click="refreshTag()">
                            <iconSymbol class="aiset-input-refresh" name="ai3-refresh"></iconSymbol>
                            <span>{{ $t("inputTitle") }}</span>
                        </div>
                    </div>
                </div>
                <AiMsgList
                    ref="msgList"
                    :agree="agreePlus"
                    :talkStatus="talkStatus"
                    @selfScrollTo="selfScrollTo"
                    @toggleBan="toggleBan"
                    @handleShowAgree="handleShowAgree"
                    @toggleAIStatus="toggleAIStatus"
                    @setTalkStatus="setTalkStatus"
                    @setAnalyseId="setAnalyseId"
                    @setFlowchartCheck="setFlowchartCheck"
                />
            </div>
            <div class="aiset-input" ref="userInput">
                <!-- <div class="aiset-input-tagbox aiset-input-analysetag" v-show="analyseList.length > 0">
                    <div class="aiset-tagbox-item" v-for="item in analyseList" :key="item.label" @click="clickAnalyseItem(item.id, $t(item.label))">
                        <p :title="item.label">{{ $t(item.label) }}</p>
                    </div>
                </div> -->

                <div class="aiset-quit" @click="forceQuit" v-show="banStatus">
                    <div class="quit-btn">
                        <div class="imgblock">
                            <iconSymbol name="ai-quit-circle" class="rotate" />
                            <iconSymbol name="ai-quit" />
                        </div>
                        <p>{{ $t("quit") }}</p>
                    </div>
                </div>
                <div class="aiset-input-toolbox">
                    <div class="left">
                        <div ref="dropdownBox" class="left-dropdown" :class="{ disabled: banStatus }">
                            <Dropdown trigger="custom" :placement="'top-start'" :visible="visible" ref="dropdown">
                                <div class="aiset-toolbox-menu" :class="{ active: visible }" @click="handleOpen">
                                    <p
                                        :content="$t(this.aiStatus)"
                                        v-tippy="{
                                            placement: 'bottom',
                                        }"
                                    >
                                        {{ $t(this.aiStatus) }}
                                    </p>
                                    <iconSymbol class="down-arrow" name="aiset-arrow"></iconSymbol>
                                </div>
                                <DropdownMenu slot="list">
                                    <div class="prompt-list-wrapper">
                                        <MenuList
                                            :menuList="menulist"
                                            @handleClicks="handleClickMenu(arguments)"
                                            class="menu-list-wrapper"
                                            ref="menuListWrapper"
                                            :key="lang"
                                        />
                                    </div>
                                    <div class="ai-prompt-tips">
                                        <div class="left">
                                            <iconSymbol class="down-arrow" name="select-up" @click.native.prevent="handleSelectUp"></iconSymbol>
                                            <iconSymbol class="down-arrow" name="select-down" @click.native.prevent="handleSelectDown"></iconSymbol>
                                            <span>{{ $t("ToNavigate") }}</span>
                                        </div>
                                        <div class="right">
                                            <iconSymbol class="down-arrow" name="select-enter" @click.native.prevent="handleSelectEnter"></iconSymbol>
                                            <span>{{ $t("selectMode") }}</span>
                                        </div>
                                    </div>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                        <div
                            class="aiset-toolbox-icon select-file-icon"
                            :class="{ 'can-use': !banStatus && aiStatus !== 'pictureAnalysis' }"
                            @click="clickUploadFile"
                            :content="!fileData ? $t('uploadFile') : $t('replaceFile')"
                            v-tippy="{
                                placement: 'bottom',
                            }"
                        >
                            <iconSymbol class="icon" :name="!fileData ? 'select-file' : 'replace-file'" />
                            <input ref="importInput" type="file" :accept="normalFileTypes" style="display: none" @change="addFile($event)" />
                        </div>
                        <div
                            class="aiset-toolbox-icon select-image-icon"
                            @click="handleUploadImg"
                            :content="$t('uploadPicture')"
                            v-tippy="{
                                placement: 'bottom',
                            }"
                            :class="{ 'can-use': canUseSelectImage }"
                        >
                            <iconSymbol class="icon" name="select-image" />
                            <input
                                ref="importImgInput"
                                type="file"
                                :accept="imgFileTypes"
                                multiple
                                style="display: none"
                                @change="handleAddImgFile($event)"
                            />
                        </div>
                    </div>
                    <div class="right">
                        <div
                            class="aiset-toolbox-icon clear-chart"
                            @dblclick="handleQuitCurrentMode"
                            @click="handleClearChat"
                            :content="$t('clearChat')"
                            v-tippy="{
                                placement: 'bottom',
                            }"
                        >
                            <iconSymbol class="icon" name="clear-chat" />
                        </div>
                    </div>
                    <!-- <div class="aiset-toolbox-icon" :title="!fileData ? $t('uploadFile') : $t('replaceFile')">
                        <img v-if="fileData == null" src="@/app/assets/img/ai3/upload.svg" alt="" @click="clickUploadFile" />
                        <img v-else src="@/app/assets/img/ai3/replace.svg" alt="" @click="clickReplaceFile" />
                        <input ref="importInput" type="file" accept=".pdf,.txt,.doc,.docx" style="display: none" @change="addFile($event)" />
                    </div> -->
                </div>
                <div
                    class="aiset-input-area"
                    :class="{ 'active-input': !!userInputStr }"
                    ref="aisetInputArea"
                    :style="{ minHeight: fileData || imgData.length ? '201px' : '88px' }"
                    @dragenter="fileDragenter($event)"
                    @dragleave="fileDragleave($event)"
                    @dragover="fileDragOver($event)"
                    @drop="fileDrop($event)"
                >
                    <div class="upload-file-list" v-if="fileData">
                        <div class="input-file">
                            <img class="icon" :src="require(`@/app/assets/img/ai3/${fileIconName}.svg`)" alt="" />
                            <!-- <p class="text" :title="fileData.fileName">{{ shortText(fileData.fileName) }}</p> -->
                            <div class="closebtn">
                                <iconSymbol class="close" name="delete-file" @click.native="cleanFile" />
                            </div>
                        </div>
                        <div class="prompt-tag">
                            <div class="tag-item" v-for="item in filePromptList" :key="item" @click="handleAddPromptTag(item)">{{ item }}</div>
                        </div>
                    </div>
                    <div class="upload-file-list image-list" v-if="imgData.length">
                        <div class="img-file-wrapper">
                            <div class="input-file img-file" v-for="(item, index) of imgData" :key="item.fileName">
                                <div class="icon-t">
                                    <img class="icon" :class="{ radius: item.setRadius }" :src="item.url" alt="" />
                                </div>
                                <div class="closebtn">
                                    <iconSymbol class="close" name="delete-file" @click.native="handleCleanImageFile(index)" />
                                </div>
                            </div>
                        </div>
                        <div class="prompt-tag">
                            <div class="tag-item" v-for="item in picturePromptList" :key="item" @click="handleAddPromptTag(item)">{{ item }}</div>
                        </div>
                    </div>
                    <Input
                        ref="inputArea"
                        type="textarea"
                        :value="userInputStr"
                        @on-change="handleChange($event)"
                        :placeholder="$t('placeholder')"
                        :autosize="{ minRows: 1, maxRows: 9 }"
                        :maxlength="1000"
                        @on-enter=""
                        @keydown.native="handleInputKeyDown"
                        @keypress.enter.native.prevent="sendMsg"
                    />
                    <div class="input-expand">
                        <p class="input-count" v-show="userInputStr.length">{{ userInputStr.length + "/1000" }}</p>
                        <p class="input-count" v-show="!userInputStr"></p>
                        <div class="aiset-toolbox-sendbtn" :class="{ ban: banStatus || disabledSendBtn }" :title="$t('send')" @click="sendMsg">
                            <!-- <img src="@/app/assets/img/ai4/send.svg" alt="" /> -->
                            <iconSymbol name="ai4-send" class="item-icon" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AiAgreement :status="agreeStatus" v-if="showAgree" @handleAgree="handleAgree" @handleRead="handleRead" />
        <aiFeedback v-if="showFeedback" @confirmFeedback="confirmFeedback"></aiFeedback>
        <input ref="echartImportInput" type="file" :accept="excelFileTypes" style="display: none" @change="addEchartFile($event)" />
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import AiMsgList from "@/app/components/ai3/aiMsgList.vue";
    import MenuList from "@/app/components/MenuList.vue";
    import AiAgreement from "@/app/components/ai3/aiAgreement.vue";
    import aiFeedback from "@/app/components/ai3/aiFeedback.vue";
    import axios from "axios";
    import { urls } from "@/public/utils/env.js";
    import { aiResType, aiStatusType, userMsgType } from "@/app/components/ai3/enum";
    import throttle from "lodash/throttle";
    import { getQueryString } from "@/public/utils/tool";
    import { blobToBase64 } from "@/public/utils/tool.js";

    @Component({
        components: {
            AiMsgList,
            MenuList,
            AiAgreement,
            aiFeedback,
            aiTips: () => import("@/app/components/ai3/aiTips.vue"),
        },
    })
    export default class AISet extends Vue {
        @Prop() screenData;
        // scrollboxHeight = "calc(100% - 148px)";
        userInputStr = "";
        promptEnter = false;
        visible: boolean = false;
        recordList = [];
        banStatus = false;
        selectIndex = 0;
        normalFileTypes = ".pdf,.txt,.doc,.docx";
        imgFileTypes = ".jpg,.png,.jpeg";
        excelFileTypes = ".xlsx,.xls,.csv";

        hideTopBg = false;

        position = {
            right: 66,
            top: 16,
        };

        get canUseSelectImage() {
            return (!this.banStatus && this.aiStatus === "chat") || this.aiStatus === "pictureAnalysis";
        }

        get showAgree() {
            return (!this.agree && this.showAgreement && !this.noLoginEditor) || this.agreeStatus;
        }

        get hideBg() {
            // console.log(this.sentMsg, this.aiStatus, this.hideTopBg, this.showAgree);
            return (this.sentMsg && this.aiStatus !== "chat") || this.hideTopBg || this.showAgree;
        }

        get showAIPanel() {
            return this.$store.state.ui.showAIPanel;
        }

        get wrapperPosition() {
            return `right: ${this.position.right}px; top: ${parseFloat(this.screenData.top) + this.position.top}px; bottom: 48px;`;
        }

        checkFileType(file, fileTypes) {
            let acceptFileTypes = fileTypes.split(",");
            let ext = file.name.split(".").pop().toLowerCase();
            let fileExtName = `.${ext}`;
            return !acceptFileTypes.includes(fileExtName);
        }

        @Watch("showAIPanel")
        watchShowAIPanel(val, old) {
            if (val && !old) {
                this.checkPoint();
                if (this.$refs.msgList as any) {
                    (this.$refs.msgList as any).displayCheck();
                }
                this.selfScrollTo();
            }
        }

        @Watch("userInfo")
        watchUserInfo(val) {
            this.readLocal();
        }
        // 检查剩余点数
        pointNum = "";
        prevPoint = 0;
        checkPoint(show = false) {
            if (this.userInfo.user_id && this.userInfo.token) {
                this.$edApi.getPoints(this.userInfo).then((res) => {
                    let num = res.balance;
                    if (num > 100000) {
                        this.pointNum = `${Math.floor(num / 1000)}K`;
                    } else {
                        this.pointNum = num;
                    }
                    const used = this.prevPoint - res.balance;
                    if (used > 0 && show && this.aiConsumePointsVisble) {
                        let usedStr = `<span style="color: #09c2ff">${used}</span>`;
                        let str = this.aiConsumePointsText
                            ? this.aiConsumePointsText.replace(/%1/, usedStr)
                            : (this.$t("pointToast") as string).replace(/\%used\%/, usedStr);
                        this.$edMessage.info(str, 3);
                    }
                    this.prevPoint = num;
                });
            }
        }
        refreshAiPoint(show = false) {
            this.checkPoint(show);
        }

        get pointLink() {
            const availableLang = ["de", "fr", "es", "pt", "it", "jp"].includes(this.lang) ? `/${this.lang}` : "no";
            let host = this.internal
                ? "https://www.edrawsoft.cn/order/recharge-page.html"
                : `https://www.edrawsoft.com${availableLang}/pricing-ai-edrawmax.html`;
            if (!this.internal && availableLang == "no") {
                host = "https://edrawmax.wondershare.com/store/pricing-ai.html";
            }
            if (!this.internal && this.lang == "en") {
                // 仅en跳转固定链接
                host = "https://www.edrawmax.com/store/effects-buy.html";
            }
            let custom = encodeURIComponent(btoa(JSON.stringify({ id: this.userInfo.user_id, token: this.userInfo.token })));
            return `${host}?product=max&platform=maxonline&custom=${custom}`;
        }
        toBuyPoint() {
            window.open(window.EDCONFIG.IS_SDK ? `http://www.edraw.ai/pricing-ai.html` : this.pointLink, "_blank");
        }

        get filePromptList() {
            return [this.$t("explainthisfile")];
        }

        get picturePromptList() {
            return [this.$t("analyzePicture")];
        }

        get newPresetList() {
            let result = [
                window.EDCONFIG.IS_SDK ? null : { key: 1, label: this.$t("preset-tag-2"), command: "yt_max_application", img: "preset-tag-text" },
                { key: 3, label: this.$t("preset-tag-4"), img: "preset-tag-text" },
                this.internal
                    ? {
                          key: 0,
                          label: this.$t("preset-tag-1"),
                          command: "yt_ai_application",
                          img: "preset-tag-text",
                      }
                    : null,
                {
                    key: "flowchart",
                    label: this.$t("createFlowChart"),
                    img: "preset-tag-flowchart",
                },

                !this.internal
                    ? {
                          key: "pictureAnalysis",
                          label: this.$t("picture"),
                          img: "preset-tag-picture",
                      }
                    : null,

                {
                    key: "echart",
                    label: this.$t("uploadDataToChart"),
                    img: "preset-tag-chart",
                },
                !this.internal
                    ? {
                          key: 0,
                          label: this.$t("preset-tag-1"),
                          command: "yt_ai_application",
                          img: "preset-tag-text",
                      }
                    : null,
                !this.internal
                    ? null
                    : {
                          key: 2,
                          label: this.$t("preset-tag-3"),
                          command: "yt_school_lessons",
                          img: "preset-tag-text",
                      },
                { key: 4, label: this.$t("preset-tag-5"), img: "preset-tag-text" },
                { key: 5, label: this.$t("preset-tag-6"), img: "preset-tag-text" },
                { key: 6, label: this.$t("preset-tag-7"), img: "preset-tag-text" },
                { key: 7, label: this.$t("preset-tag-8"), img: "preset-tag-text" },
                { key: 8, label: this.$t("preset-tag-9"), img: "preset-tag-text" },
                { key: 9, label: this.$t("preset-tag-10"), img: "preset-tag-text" },
                { key: 10, label: this.$t("preset-tag-11"), img: "preset-tag-text" },
                { key: 11, label: this.$t("preset-tag-12"), img: "preset-tag-text" },
                { key: 12, label: this.$t("preset-tag-13"), img: "preset-tag-text" },
                { key: 13, label: this.$t("preset-tag-14"), img: "preset-tag-text" },
            ].filter(Boolean);

            return result;
        }

        firstFlag = true;
        get noLoginEditor() {
            return this.$store.state.user.noLoginEditor;
        }
        get displayTaglist() {
            let list = this.newPresetList.filter((item) => !this.recordList.includes(item.key));

            const resultList = this.firstFlag ? [...list.slice(0, 5)] : this.shuttle(list).slice(0, 5);
            return resultList;
        }
        get menulist() {
            let list = [
                {
                    key: "chat",
                    label: this.$t("chat"),
                    trackUseType: "",
                    id: "promptChat",
                    active: false,
                    isTitle: true,
                    index: 0,
                },
                { divide: true },
                {
                    key: "diagram",
                    label: this.$t("diagram"),
                    trackUseType: "diagram",
                    isTitle: true,
                    disabled: true,
                },
                {
                    key: "flowchart",
                    label: this.$t("flowchart"),
                    trackUseType: "Flowchart",
                    active: false,
                    id: "promptFlowchart",
                    index: 1,
                },
                {
                    key: "mindmap",
                    label: this.$t("mindmap"),
                    trackUseType: "Mind Map",
                    active: false,
                    id: "promptMindMap",
                    index: 2,
                },
                {
                    key: "timeline",
                    label: this.$t("timeline"),
                    trackUseType: "Timeline",
                    active: false,
                    id: "promptTimeline",
                    index: 3,
                },
                {
                    key: "list",
                    label: this.$t("list"),
                    trackUseType: "List",
                    active: false,
                    id: "promptList",
                    index: 4,
                },
                {
                    key: "table",
                    label: this.$t("table"),
                    trackUseType: "Table",
                    active: false,
                    id: "promptTable",
                    index: 5,
                },
                { divide: true },
                {
                    key: "aiAnalysis",
                    label: this.$t("aiAnalysis"),
                    trackUseType: "aiAnalysis",
                    isTitle: true,
                    disabled: true,
                },
                {
                    key: "pictureAnalysis",
                    label: this.$t("pictureAnalysis"),
                    trackUseType: "Picture Analysis",
                    active: false,
                    id: "promptDiagramAnalysis",
                    index: 6,
                },
                {
                    key: "documentAnalysis",
                    label: this.$t("documentAnalysis"),
                    trackUseType: "Document Analysis",
                    active: false,
                    id: "promptDocumentAnalysis",
                    index: 7,
                },
                {
                    key: "textAnalysis",
                    label: this.$t("textAnalysis"),
                    trackUseType: "Text Analysis",
                    active: false,
                    id: "promptTextAnalysis",
                    index: 27,
                },
                { divide: true },
                {
                    key: "chart",
                    label: this.$t("chart"),
                    trackUseType: "chart",
                    isTitle: true,
                    disabled: true,
                },
                {
                    key: "line",
                    label: this.$t("line"),
                    trackUseType: "Line Chart",
                    active: false,
                    id: "promptLineChart",
                    index: 8,
                },
                {
                    key: "bar",
                    label: this.$t("bar"),
                    trackUseType: "Bar Chart",
                    active: false,
                    id: "promptBarChart",
                    index: 9,
                },
                {
                    key: "pie",
                    label: this.$t("pie"),
                    trackUseType: "Pie Chart",
                    active: false,
                    id: "promptPieChart",
                    index: 10,
                },
                {
                    key: "scatter",
                    label: this.$t("scatter"),
                    trackUseType: "Scatter Plot",
                    active: false,
                    id: "promptScatterPlot",
                    index: 11,
                },
                {
                    key: "candlestick",
                    label: this.$t("candlestick"),
                    trackUseType: "Candlestick Chart",
                    active: false,
                    id: "promptCandleStick",
                    index: 12,
                },
                {
                    key: "radar",
                    label: this.$t("radar"),
                    trackUseType: "Radar Chart",
                    active: false,
                    id: "promptRadarChart",
                    index: 13,
                },
                // {
                //     key: "boxplot",
                //     label: this.$t("boxplot"),
                //     trackUseType: "Box Plot",
                //     active: false,
                //     id: "promptBoxPlot",
                //     index: 14,
                // },
                // {
                //     key: "heatmap",
                //     label: this.$t("heatmap"),
                //     trackUseType: "Heat Map",
                //     active: false,
                //     id: "promptHeatmap",
                //     index: 15,
                // },
                // {
                //     key: "graphChart",
                //     label: this.$t("graphChart"),
                //     trackUseType: "Relational Graph",
                //     active: false,
                //     id: "promptGraph",
                //     index: 16,
                // },
                // {
                //     key: "sunburst",
                //     label: this.$t("sunburst"),
                //     trackUseType: "Sunburst Chart",
                //     active: false,
                //     id: "promptSunburst",
                //     index: 17,
                // },
                {
                    key: "parallel",
                    label: this.$t("parallel"),
                    trackUseType: "Parallel Coordinates",
                    active: false,
                    id: "promptParallel",
                    index: 18,
                },
                {
                    key: "sankey",
                    label: this.$t("sankey"),
                    trackUseType: "Sankey Diagram",
                    active: false,
                    id: "promptSankeyt",
                    index: 19,
                },
                {
                    key: "funnel",
                    label: this.$t("funnel"),
                    trackUseType: "Funnel Chart",
                    active: false,
                    id: "promptFunnel",
                    index: 20,
                },
                {
                    key: "gauge",
                    label: this.$t("gauge"),
                    trackUseType: "Dial",
                    active: false,
                    id: "promptGauge",
                    index: 21,
                },
                { divide: true },
                {
                    key: "other",
                    label: this.$t("other"),
                    trackUseType: "other",
                    isTitle: true,
                    disabled: true,
                },
                {
                    key: "canvas",
                    label: this.$t("canvas"),
                    trackUseType: "Lean Canvas",
                    active: false,
                    id: "promptCanvas",
                    index: 22,
                },
                {
                    key: "pest",
                    label: this.$t("pest"),
                    trackUseType: "PEST Analysis",
                    active: false,
                    id: "promptPest",
                    index: 23,
                },
                {
                    key: "swot",
                    label: this.$t("swot"),
                    trackUseType: "SWOT Analysis",
                    active: false,
                    id: "promptSwot",
                    index: 24,
                },
                // { divide: true },
                {
                    key: "story",
                    label: this.$t("story"),
                    trackUseType: "User Story",
                    active: false,
                    id: "promptStory",
                    index: 25,
                },
                {
                    key: "portrait",
                    label: this.$t("portrait"),
                    trackUseType: "User Profile",
                    active: false,
                    id: "promptPortrait",
                    index: 26,
                },
            ];
            if (window.EDCONFIG.IS_SDK) {
                list = list.filter((v) => v.key !== "mindmap" && v.key !== "timeline");
            }
            if (this.internal) {
                list = list.filter((v) => v.key !== "pictureAnalysis");
            }
            // let list = [

            // ];
            list.forEach((v, i) => {
                if (v.index === this.selectIndex) {
                    v.active = true;
                }
            });
            if (this.userInputStr.startsWith("/")) {
                let searchText = this.userInputStr.slice(1);
                if (searchText) {
                    let reg = new RegExp(searchText, "gi");
                    list = list.filter((v) => !(v.divide || v.isTitle) && reg.test(v.label as string));
                }
            }
            return {
                list,
            };
        }

        @Watch("menulist.list")
        watchMenuList(val) {
            if (val?.length === 1) {
                this.selectIndex = val[0].index;
            } else if (val?.length === 0) {
                this.visible = false;
                window.removeEventListener("click", this.closeDropdown);
            }
        }
        handleAddPromptTag(item) {
            if (this.userInputStr.length >= 1000) {
                this.$edMessage.error(this.$t("overTextLength"));
                return;
            }
            let str = this.userInputStr;
            str = str.concat(item);
            if (str.length >= 1000) {
                this.$edMessage.error(this.$t("overTextLength"));
                return;
            }
            this.userInputStr = str;
        }

        handleClickPreset(item) {
            if (!this.agreePlus) {
                this.handleShowAgree();
                return;
            }

            this.sensors.track("promptPreset", {
                Catalogues: "AI",
                click_type: item.label,
            });

            const { key } = item;
            let msgList: any = this.$refs.msgList;
            if (typeof key === "number") {
                if (item.command) {
                    msgList.msgEvent({
                        action: "presetTag",
                        key: item.key,
                        str: item.command,
                        botUserInput: item.label,
                    });
                } else {
                    msgList.msgEvent({
                        action: "clickTag",
                        key: item.key,
                        str: item.label,
                    });
                }
            } else if (key === "flowchart") {
                this.aiStatus = key;
                this.selectIndex = this.menulist.list.find((v) => v.key === "flowchart").index;
                this.$bus.$emit("aiClickImglist", key);
            } else if (key === "pictureAnalysis") {
                this.handleUploadImg();
            } else if (key === "echart") {
                this.clickUploadEchart();
            }
        }

        shuttle(array) {
            for (let i = array.length - 1; i >= 0; i--) {
                let random = Math.floor(Math.random() * i);
                let t = array[random];
                array[random] = array[i];
                array[i] = t;
            }
            return array;
        }

        // scrollHeightFit() {

        //     const watchHeight = () => {
        //         const dom = this.$refs.userInput as HTMLElement;
        //         console.log(getComputedStyle(dom).height);
        //         this.scrollboxHeight = `calc(100% - ${getComputedStyle(dom).height})`;
        //     };
        //     let observer = new MutationObserver(watchHeight);
        //     observer.observe(this.$refs.userInput as HTMLElement, {
        //         characterData: true,
        //         childList: true,
        //         subtree: true,
        //         attributes: true,
        //     });
        // }

        handleChange(e) {
            const text = e.target.value;
            this.userInputStr = text;
            if (text.startsWith("/")) {
                this.handleOpen();
            } else if (!text) {
                this.handleClose();
                return;
            }
            this.$nextTick(() => {
                (this.$refs.dropdown as any).$refs.drop.update();
            });
        }

        handleOpen() {
            if (this.visible) {
                if (this.userInputStr.startsWith("/")) {
                    return;
                }
                this.handleClose();
                return;
            }
            this.visible = true;
            this.$nextTick(() => {
                this.resizeImmediately();
            });
            window.addEventListener("click", this.closeDropdown);
        }

        handleClose() {
            this.visible = false;
            window.removeEventListener("click", this.closeDropdown);
        }

        closeDropdown(e) {
            let objTarget = this.$refs.dropdownBox as HTMLElement;
            if (objTarget != e.target && !objTarget?.contains(e.target)) {
                if (this.userInputStr.startsWith("/")) {
                    return;
                }
                this.visible = false;
                window.removeEventListener("click", this.closeDropdown);
            }
        }

        handleQuitCurrentMode() {
            let msgList: any = this.$refs.msgList;
            msgList.cleanStatus();
        }
        handleClearChat() {
            let msgList: any = this.$refs.msgList;
            msgList.stopTask(false);
            // 清除对话，不切换模式
            setTimeout(() => {
                msgList.clearMsgList();
            }, 200);
            this.sensors.track("clearChat", {
                Catalogues: "AI",
            });
            this.setTalkStatus(2);
        }

        handleClickMenu(args) {
            if (!this.agreePlus) {
                this.handleClose();
                this.handleShowAgree();
                return;
            }
            let key = args[0],
                event = args[1];
            if (this.aiStatus === "pictureAnalysis" && key !== "pictureAnalysis") {
                this.clearImgFiles();
            }
            if (key === "pictureAnalysis") {
                this.cleanFile();
            }
            this.aiStatus = key;
            let curItem = this.menulist.list.find((v) => v.key === key);
            if (!curItem || !("index" in curItem)) return;
            this.selectIndex = curItem.index;
            this.echartFileData = null;
            //  切换模式，不清除历史对话
            if (key === "chat") {
                let msgList: any = this.$refs.msgList;
                msgList.cleanStatus();
                this.handleClose();
                return;
            }
            this.$bus.$emit("aiClickImglist", key);
            this.handleClose();
            this.trackClick(key);
        }

        trackClick(key) {
            let trackUseType = "";
            this.menulist.list.forEach((item) => {
                if (item.key === key) {
                    trackUseType = item.trackUseType;
                }
            });

            if (trackUseType !== "") {
                this.sensors.track("useButtonTab", {
                    Catalogues: "AI",
                    use_type: trackUseType,
                });
            }
        }

        closeRightMenu() {
            this.$bus.$emit("showAIPanel", false);
        }

        aiStatus = "chat";
        toggleAIStatus(data) {
            // 切换预置场景，含退出
            if (data === "chat" || data === null) {
                // 退出模式
                data = "chat";
                this.sentMsg = false;
                this.selectIndex = 0;
            } else {
                let item = this.menulist.list.find((v) => v.key === data);
                if (item) {
                    this.selectIndex = item.index;
                }
            }
            if (!this.sentMsg && this.selectIndex !== 0) {
                this.sentMsg = true;
            }
            this.aiStatus = data;
            // // 如连续对话是开启状态，则恢复至初条消息
            // this.talkStatus == 2 && this.setTalkMode(1);
            // if (data == "flowchart") {
            //     // 需求：流程图强制进入连续对话
            //     this.setTalkMode(2);
            // }
        }
        sentMsg = false; // 有对话内容

        refreshTag() {
            this.firstFlag = false;
            if (this.recordList.length >= 10) {
                this.recordList = [];
            } else {
                let arr = this.displayTaglist.map((item) => item.key);

                this.recordList.push(...arr);
            }
            this.sensors.track("tryMore", {
                Catalogues: "AI",
            });
        }

        clickTag(item, index) {
            if (!this.agreePlus) {
                this.handleShowAgree();
                return;
            }
            if (this.banStatus) {
                return;
            }
            // this.activeTag.index = index;
            // this.activeTag.key = item.key;
            this.banStatus = true;
            let msgList: any = this.$refs.msgList;
            if (item.command) {
                msgList.msgEvent({
                    action: "presetTag",
                    key: item.key,
                    str: item.command,
                    botUserInput: item.label,
                });
            } else {
                msgList.msgEvent({
                    action: "clickTag",
                    key: item.key,
                    str: item.label,
                });
            }
        }

        get disabledSendBtn() {
            const msg = this.userInputStr.trim();
            return !msg && !this.fileData && !this.imgData.length && !this.echartFileData;
        }

        handleInputKeyDown($event: Event) {
            const event = $event as KeyboardEvent;
            const ele = (this.$refs.inputArea as any).$refs.textarea as HTMLInputElement;
            const shortCutKeys: (keyof KeyboardEvent)[] = [
                // 'metaKey', 'altKey', 'ctrlKey',
                "shiftKey",
            ];
            const isEnterKey = event.key === "Enter";
            const isShortcutKeys = shortCutKeys.some((item) => event[item]);
            if (isEnterKey && isShortcutKeys) {
                const cursorPosition = ele.selectionStart;
                const newInput = `${this.userInputStr.slice(0, cursorPosition)}${`\n`}${this.userInputStr.slice(cursorPosition)}`;
                this.userInputStr = newInput;
                this.$nextTick(() => {
                    ele.setSelectionRange(cursorPosition + 1, cursorPosition + 1);
                });
            }
        }

        sendMsg(e) {
            if (this.promptEnter) {
                this.promptEnter = false;
                return;
            }
            if (!this.agreePlus) {
                this.handleShowAgree();
                return;
            }
            if (e.shiftKey || this.banStatus) {
                return;
            }

            if (this.disabledSendBtn) {
                this.$edMessage.warning(this.$t("inputNotNull"));
                this.userInputStr = "";
                return;
            }
            this.sentMsg = true;
            const userInput = this.userInputStr;
            this.userInputStr = "";
            this.banStatus = true;
            let msgList: any = this.$refs.msgList;
            if (this.flowchartFlag) {
                // todo 检验用户输入是否符合流程图分析规则
                msgList.msgEvent({
                    action: "userMsg",
                    str: userInput,
                });
                const shapeStr = window["_view"].getFlowPrompt();
                msgList.msgEvent({
                    action: "flowAnalyse",
                    str: userInput,
                    shapeStr: shapeStr[0],
                });
                this.flowchartFlag = false;
            } else if (this.fileData) {
                const fileName = this.fileData.fileName;
                msgList.msgEvent({
                    action: "userMsg",
                    str: userInput,
                    msgType: userMsgType.file,
                    fileType: this.fileData.fileType,
                    fileName: this.fileData.fileName,
                });
                this.aiParseFile()
                    .then((res) => {
                        const parseStr = res.data;
                        if (res.data == "") {
                            msgList.msgEvent({
                                action: "botMsg",
                                msgType: aiResType.text,
                                str: this.$t("file-null"),
                            });
                            this.banStatus = false;
                        } else {
                            msgList.msgEvent({
                                action: "fileTask",
                                str: userInput,
                                extra: parseStr,
                                fileName: fileName.replace(/(.*\/)*([^.]+).*/gi, "$2"),
                            });
                            this.sensors.track("sendsuccessfully", {
                                Catalogues: "AI",
                                send_type: userInput ? "textAndFile" : "fileOnly",
                            });
                        }
                    })
                    .catch((e) => {
                        if (e.response && e.response.data && e.response.data.code == 3009) {
                            msgList.msgEvent({
                                action: "botMsg",
                                msgType: aiResType.text,
                                str: this.$t("file-format"),
                            });
                        } else {
                            msgList.msgEvent({
                                action: "botMsg",
                                msgType: aiResType.text,
                                str: this.$t("file-error"),
                            });
                        }
                        this.banStatus = false;
                    });
            } else if (this.echartFileData) {
                msgList.msgEvent({
                    action: "userMsg",
                    str: userInput,
                    msgType: userMsgType.file,
                    fileType: this.echartFileData.fileType,
                    fileName: this.echartFileData.fileName,
                });
                this.sendEchartInfo(userInput);
            } else if (this.imgData.length) {
                const pictures = this.imgData.map((v) => ({ url: v.url, htw: v.htw, wth: v.wth }));

                const imgDatas = this.imgData.map((item) => {
                    return {
                        mime_type: /png/.test(item.fileType.toLowerCase()) ? "image/png" : "image/jpeg",
                        data: item.data?.split(",")?.[1],
                    };
                });
                msgList.msgEvent({
                    action: "userMsgForPicture",
                    str: userInput,
                    msgType: userMsgType.picture,
                    pictures,
                });
                this.sensors.track("sendPicSuccessfully", {
                    Catalogues: "AI",
                });

                msgList.msgEvent({
                    action: "pictureTask",
                    str: userInput,
                    imgDatas,
                });

                this.clearImgFiles();
            } else {
                msgList.msgEvent({
                    action: "userMsg",
                    str: userInput,
                });
                msgList.msgEvent({
                    action: "userTask",
                    str: userInput,
                });
            }
        }
        sendBotMsg(str) {
            let msgList: any = this.$refs.msgList;
            msgList.msgEvent({
                action: "botMsg",
                msgType: aiResType.text,
                str: str,
            });
        }

        selfScrollTo() {
            const box = this.$refs.msgScrollbox as HTMLElement;
            const offset = box.scrollHeight - box.clientHeight;
            offset && box.scrollTo(0, offset);
        }

        handleScroll() {
            const box = this.$refs.msgScrollbox as HTMLElement;
            this.hideTopBg = box.scrollTop > 75;
        }

        talkStatus = 2;
        get aiContinuousTipFlag() {
            return this.$store.state.staticConfig.aiContinuousTipFlag;
        }

        setTalkStatus(data: number) {
            // 1 | 2 | 3  关闭 | 接口参数首次传值1 | 后续传sessionid
            this.talkStatus = data;
        }

        // 文件相关

        fileDragenter(e) {
            (this.$refs.aisetInputArea as HTMLElement).classList.add("drag-enter");
        }
        fileDragleave(e) {
            (this.$refs.aisetInputArea as HTMLElement).classList.remove("drag-enter");
        }
        fileDragOver(e) {
            // 禁止浏览器默认事件
            e.preventDefault();
            (this.$refs.aisetInputArea as HTMLElement).classList.add("drag-enter");
        }
        fileDrop(e) {
            // 拖拽上传图片
            e.stopPropagation();
            e.preventDefault();
            let files = e.dataTransfer.files;
            let file = files[0];
            let acceptFileTypes = this.imgFileTypes.split(",");
            files = Array.from(files).filter((file: any) => {
                let fileExtName = `.${file.name.split(".").pop().toLowerCase()}`;
                return acceptFileTypes.includes(fileExtName);
            });
            (this.$refs.aisetInputArea as HTMLElement).classList.remove("drag-enter");
            if (!files.length) {
                this.$edMessage.error(this.$t("canDragPicture"));
                return;
            }
            let checked = this.checkImgFileSize(files);
            if (!checked) return;
            this.addImgFile(files);
        }
        fileData = null;
        fileIconName = "";
        clickUploadFile() {
            if (this.aiStatus === "pictureAnalysis") return;
            if (this.chartStatus) {
                this.clickUploadEchart();
                return;
            }
            (this.$refs.importInput as HTMLElement).dispatchEvent(new MouseEvent("click"));
            this.sensors.track("clickUploadfile", {
                Catalogues: "AI",
            });
        }
        clickReplaceFile() {
            (this.$refs.importInput as HTMLElement).click();
        }
        clickUploadEchart() {
            (this.$refs.echartImportInput as HTMLInputElement).dispatchEvent(new MouseEvent("click"));
        }
        addFile(e) {
            this.clearImgFiles();
            this.clearEchartFile();
            let file = e.target.files[0];
            let hasErrorType = this.checkFileType(file, this.normalFileTypes);
            e.target.value = null;
            if (hasErrorType) {
                this.$edMessage.error(this.$t("uploadRightFileType"));
                return;
            }
            let fileName = file.name;
            let fileType = fileName.split(".").pop();
            this.fileData = {
                fileName: fileName,
                file: file,
                fileType: fileType,
            };
            this.fileIconName = fileType == "txt" ? "txt" : fileType == "pdf" ? "pdf" : "doc";
        }

        imgData = [];
        handleUploadImg() {
            if (!this.canUseSelectImage) return;
            (this.$refs.importImgInput as HTMLElement).dispatchEvent(new MouseEvent("click"));
            this.sensors.track("clickUploadPic", {
                Catalogues: "AI",
            });
        }

        checkImgFileSize(files) {
            if (this.imgData.length + files.length > 3) {
                this.$edMessage.error(this.$t("uploadImgLimit"));
                (this.$refs.importImgInput as any).value = "";
                return false;
            }
            const maxSize = 20 * 1024 * 1024; // 20 mb
            const hasOverSizeFile = files.some((file) => file.size > maxSize);
            if (hasOverSizeFile) {
                this.$edMessage.error(this.$t("uploadImgOverSize"));
                (this.$refs.importImgInput as any).value = "";
                return false;
            }
            let hasErrorType = files.some((file) => this.checkFileType(file, this.imgFileTypes));
            if (hasErrorType) {
                this.$edMessage.error(this.$t("uploadRightFileType"));
                return false;
            }
            return true;
        }

        handleAddImgFile(e) {
            let files = Array.from(e.target.files) as any[];
            let checked = this.checkImgFileSize(files);
            e.target.value = null;
            if (!checked) return;
            this.addImgFile(files);
            this.$bus.$emit("aiClickImglist", "pictureAnalysis");
        }
        addImgFile(files) {
            this.cleanFile();
            this.clearEchartFile();
            for (let file of files) {
                let fileName = file.name;
                let fileType = fileName.split(".").pop();

                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                    let src = (e.target as any).result;
                    let img = new Image();
                    img.src = src;
                    img.onload = () => {
                        let w = img.width;
                        let h = img.height;
                        let wth = w / h;
                        let htw = h / w;
                        let d = Math.abs(wth - 1);
                        let d1 = Math.abs(htw - 1);
                        let setRadius = d1 < 0.15 || d < 0.15;
                        this.imgData.push({
                            fileName: fileName,
                            file: file,
                            data: src,
                            fileType: fileType,
                            url: URL.createObjectURL(file),
                            setRadius,
                            htw,
                            wth,
                        });
                    };
                };
            }
        }

        shortText(str) {
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext("2d");
            ctx.font = "12px 'Microsoft YaHei'";
            let strLength = ctx.measureText(str);
            if (strLength.width > 208) {
                let pointLength = ctx.measureText("...");
                let partLength = (208 - pointLength.width) / 2;
                let strArr = str.split("");
                let prevStr = "";
                let suffStr = "";
                let extraPX = 0;
                for (let i = 0; i < strArr.length; i++) {
                    let temp = prevStr;
                    temp += strArr[i];
                    let width = ctx.measureText(temp).width;
                    if (width > partLength) {
                        extraPX = partLength - ctx.measureText(prevStr).width;
                        break;
                    }
                    prevStr = temp;
                }
                for (let i = strArr.length - 1; i >= 0; i--) {
                    let temp = suffStr;
                    temp += strArr[i];
                    let width = ctx.measureText(temp).width;
                    if (width > partLength + extraPX) {
                        break;
                    }
                    suffStr = temp;
                }
                suffStr = suffStr.split("").reverse().join("");
                return `${prevStr}...${suffStr}`;
            } else {
                return str;
            }
        }
        cleanFile() {
            this.fileData = null;
        }
        clearEchartFile() {
            this.echartFileData = null;
        }
        clearImgFiles() {
            this.imgData = [];
        }

        handleCleanImageFile(index) {
            this.imgData.splice(index, 1);
        }

        async aiAxios(type, formData) {
            let urlTypeMap = {
                file: "/parse",
                picture: "/upload/vision",
                excel: "/parse/form",
            };
            let domain = urls.edrawmaxApi;
            if (window.EDCONFIG.IS_SDK) {
                domain = urls.apiUrl;
            }
            const url = `${domain}/api/ai/v1${urlTypeMap[type]}`;
            const res = await axios.post(url, formData, {
                headers: {
                    Authorization: "Bearer " + this.userInfo.token,
                },
            });
            return res;
        }

        async uploadPictures(item) {
            const formData = new FormData();

            formData.append("file", item.file);
            const res = await this.aiAxios("picture", formData);
            return res.data;
        }

        async aiParseFile() {
            const formData = new FormData();
            formData.append("file", this.fileData.file);
            formData.append("user_id", this.userInfo.user_id);
            const res = await this.aiAxios("file", formData);
            this.cleanFile();
            return res.data;
        }

        toggleBan(v: boolean) {
            this.banStatus = v;
        }

        forceQuit() {
            let msgList: any = this.$refs.msgList;
            msgList.stopTask();
        }

        // agreement
        get userInfo() {
            return this.$store.state.user.userInfo;
        }

        get aiConsumePointsVisble() {
            return this.$store.state.staticConfig.aiConsumePointsVisble;
        }
        get aiConsumePointsText() {
            return this.$store.state.staticConfig.aiConsumePointsText;
        }
        agreeStatus = "";
        showAgreement = false;
        agree = false;
        get agreePlus() {
            return this.agree || this.noLoginEditor;
        }
        readLocal() {
            let str = localStorage.getItem("ai3") || null;
            if (str) {
                let ai3Obj = JSON.parse(str);
                let list = ai3Obj.agreement || [];
                let exit = false;
                for (let i = 0; i < list.length; i++) {
                    if (this.userInfo.user_id == list[i].user_id) {
                        exit = true;
                        this.agree = list[i].data;
                        break;
                    }
                }
                !exit && (this.agree = false);
            } else {
                this.agree = false;
            }
        }
        saveLocal() {
            let str = localStorage.getItem("ai3") || null;
            let ai3Obj = null;
            if (str) {
                ai3Obj = JSON.parse(str);
                if (!ai3Obj.hasOwnProperty("agreement")) {
                    Object.assign(ai3Obj, { agreement: [] });
                }
                let list = ai3Obj.agreement;
                list.push({
                    user_id: this.userInfo.user_id,
                    data: 1,
                });
            } else {
                ai3Obj = {
                    agreement: [
                        {
                            user_id: this.userInfo.user_id,
                            data: 1,
                        },
                    ],
                };
            }
            localStorage.setItem("ai3", JSON.stringify(ai3Obj));
        }

        get aiDrawBtn() {
            return this.$store.state.dialog.aiDrawBtn;
        }

        handleAgree(data) {
            if (!data) {
                this.showAgreement = false;
                this.selectIndex = 0;
            } else {
                this.agree = true;
                this.saveLocal();
                this.$nextTick(() => {
                    let urlData = `temp=${window.location.search.substr(1)}`;
                    if (!this.isPlugin) {
                        urlData = this.$unZipFileName(getQueryString(urlData, "temp"));
                    }
                    const aiStatus = getQueryString(urlData, "aiStatus");
                    if (aiStatus) {
                        this.$bus.$emit("aiClickImglist", aiStatus);
                    }
                    if (this.aiDrawBtn) {
                        this.showAgreement = false;
                        this.selectIndex = 0;
                        this.$bus.$emit("showAIPanel", false);
                        if (this.aiDrawBtn === "libContentContextToAidraw") {
                            this.toAidraw();
                        } else {
                            this.$bus.$emit(this.aiDrawBtn);
                        }
                    }
                });
            }
        }
        handleRead() {
            this.agreeStatus = "";
        }
        handleShowAgree() {
            this.banStatus = false;
            this.showAgreement = true;
        }
        agreeListen(status: string) {
            this.agreeStatus = status;
        }

        // 点赞反馈
        showFeedback = false;
        msgId = 0;
        aiResult = "";
        toggleFeedback(data, msgid, result = "") {
            this.showFeedback = data;
            this.msgId = msgid;
            this.aiResult = result;
        }
        closeFeedback() {
            this.showFeedback = false;
            this.aiFeedback(this.msgId, false, "", this.aiResult); // 点x关闭,只反馈分数
        }
        confirmFeedback(str) {
            this.aiFeedback(this.msgId, false, str, this.aiResult);
            this.showFeedback = false;
        }
        aiFeedback(sessionId, type, str = "", aiResult) {
            const url = `${window.EDCONFIG.IS_SDK ? urls.apiUrl : urls.edrawmaxApi}/api/ai/v1/completions/score`;
            const params = {
                session_id: sessionId,
                score: type ? 10 : 1,
                reason: str,
                assistant: aiResult,
            };
            axios
                .put(url, params, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + this.userInfo.token,
                    },
                })
                .then(() => {
                    this.sendBotMsg(type ? this.$t("likeFeedback") : this.$t("unlikeFeedback"));
                });
        }

        //形状分析
        get analyseList() {
            let arr = [];
            if (!this.aiStatus) return arr;
            switch (this.aiStatus) {
                case "gantt": {
                    arr = [
                        {
                            id: aiStatusType.ganttSummarize,
                            label: "ganttTotal",
                        },
                        {
                            id: aiStatusType.ganttProgress,
                            label: "ganttProgress",
                        },
                        {
                            id: aiStatusType.ganttRisk,
                            label: "ganttRisk",
                        },
                        {
                            id: aiStatusType.ganttExpirence,
                            label: "ganttShare",
                        },
                    ];
                    break;
                }
                case "graph": {
                    arr = [
                        {
                            id: aiStatusType.graphCompare,
                            label: "compare",
                        },
                        {
                            id: aiStatusType.graphAbnormal,
                            label: "error",
                        },
                        {
                            id: aiStatusType.graphSummary,
                            label: "summarize",
                        },
                        {
                            id: aiStatusType.graphPredict,
                            label: "trend",
                        },
                    ];
                    break;
                }
                case "org": {
                    arr = [
                        {
                            id: aiStatusType.orgAnalyse,
                            label: "analysis",
                        },
                        {
                            id: aiStatusType.orgDiagnosis,
                            label: "check",
                        },
                    ];
                    break;
                }
            }
            return arr.filter((item) => item.id != this.analyseId);
        }
        analyseId = 0;
        clickAnalyseItem(id, ustr) {
            if (!this.agreePlus) {
                this.handleShowAgree();
                return;
            }
            if (this.banStatus) {
                return;
            }
            this.banStatus = true;
            this.$bus.$emit("aiAnalyse", id, ustr);
        }
        setAnalyseId(id) {
            this.analyseId = id;
        }

        // 流程图分析-新增流程
        flowchartFlag = false;
        setFlowchartCheck() {
            this.flowchartFlag = true;
        }

        // echart 解析
        get chartStatus() {
            return [
                "line",
                "bar",
                "pie",
                "scatter",
                "candlestick",
                "radar",
                "boxplot",
                "heatmap",
                "graphChart",
                "sunburst",
                "parallel",
                "sankey",
                "funnel",
                "gauge",
            ].includes(this.aiStatus);
        }
        echartFileData = null;
        addEchartFile(e) {
            this.cleanFile();
            this.clearImgFiles();
            let file = e.target.files[0];
            e.target.value = null;
            let hasErrorType = this.checkFileType(file, this.excelFileTypes);
            if (hasErrorType) {
                this.$edMessage.error(this.$t("uploadRightFileType"));
                return;
            }
            let fileName = file.name;
            let fileType = fileName.split(".").pop();
            this.echartFileData = {
                fileName: fileName,
                file: file,
                fileType: fileType,
            };
            this.sendEchartData();
        }
        async parseExcel() {
            const getLang = () => {
                switch (this.lang) {
                    case "zh":
                        return "ch";
                    case "tw":
                        return "ch_tra";
                    case "en":
                        return "en";
                    case "kr":
                        return "ko";
                }
                return this.lang;
            };
            const formData = new FormData();
            let langStr = getLang();
            formData.append("file", this.echartFileData.file);
            formData.append("lang", langStr);
            const res = await this.aiAxios("excel", formData);
            this.echartFileData = null;
            return res.data;
        }
        sendEchartInfo(userInput) {
            if (!this.agreePlus) {
                this.handleShowAgree();
                return;
            }
            let msgList: any = this.$refs.msgList;
            const fileName = this.echartFileData.fileName;
            this.parseExcel().then((res) => {
                const parseStr = res.data;
                if (res.data == "") {
                    msgList.msgEvent({
                        action: "botMsg",
                        msgType: aiResType.text,
                        str: this.$t("file-null"),
                    });
                    this.banStatus = false;
                } else {
                    msgList.msgEvent({
                        action: "echartTask",
                        str: userInput,
                        extra: parseStr,
                        fileName: fileName.replace(/(.*\/)*([^.]+).*/gi, "$2"),
                    });
                }
            });
        }
        sendEchartData() {
            this.userInputStr = "";
            let msgList: any = this.$refs.msgList;
            msgList.msgEvent({
                action: "userMsg",
                str: this.$tc("uploadEchart"),
                msgType: userMsgType.file,
                fileType: this.echartFileData.fileType,
                fileName: this.echartFileData.fileName,
            });
            this.sendEchartInfo(this.userInputStr);
        }

        handleKeydown(e: KeyboardEvent) {
            if (e.metaKey || e.altKey || e.ctrlKey || !this.visible) {
                return;
            }
            // arrow up / down to select prompt
            // const changeIndex = (delta: number) => {

            // };

            if (e.key === "ArrowUp") {
                this.changeIndex(-1, e);
            } else if (e.key === "ArrowDown") {
                this.changeIndex(1, e);
            } else if (e.key === "Enter") {
                this.handleSelectEnter();
            }
        }

        changeIndex(delta: number, e?: any) {
            if (e) {
                e.stopPropagation();
                e.preventDefault();
            }
            // window["_view"]._tool.selectObject(null); // 清除选中
            // window["_view"].invalidate(); // 刷新缓存
            let realPromptList = this.menulist.list.filter((v) => v.index !== undefined);
            let tempIndex = realPromptList.findIndex((v) => v.index === this.selectIndex);
            let minIndex = 0;
            let maxIndex = realPromptList.length - 1;
            const nextIndex = Math.max(minIndex, Math.min(maxIndex, tempIndex + delta));
            this.selectIndex = realPromptList[nextIndex].index;
            this.$nextTick(() => {
                const selectedItem = realPromptList.find((v) => v.index === this.selectIndex);
                if (!selectedItem) return;
                let ele = document.querySelector(`#${selectedItem.id}`);
                ele.scrollIntoView({
                    block: "center",
                });
            });
        }

        handleSelectUp() {
            this.changeIndex(-1);
        }

        handleSelectDown() {
            this.changeIndex(1);
        }

        handleSelectEnter() {
            const selectedItem = this.menulist.list.find((v) => v.index === this.selectIndex);
            if (!this.agreePlus) {
                this.handleClose();
                this.handleShowAgree();
                return;
            }
            if ((selectedItem && this.userInputStr.startsWith("/")) || this.visible) {
                this.promptEnter = true;
                this.aiStatus = selectedItem.key;
                this.$bus.$emit("aiClickImglist", selectedItem.key);
                this.handleClose();
                this.userInputStr = "";
                this.trackClick(selectedItem.key);
            }
        }

        resizeImmediately = () => {
            let dropdownPanelEl = (this.$refs.menuListWrapper as any).$el as HTMLElement;
            let dropdownWrapperEle = this.$refs.dropdownBox as HTMLElement;
            let top = dropdownWrapperEle.getBoundingClientRect().top;
            let rest = top - 165;
            dropdownPanelEl.style.maxHeight = rest < 512 ? `${rest - 60}px` : "461px";
            this.$nextTick(() => {
                (this.$refs.dropdown as any).$refs.drop.update();
            });
        };
        resizeDropdown = throttle(this.resizeImmediately, 60);

        handleShowAgreement() {
            this.$store.commit("setDialogState", {
                type: "aiDrawBtn",
                data: "",
            });
            this.$bus.$emit("showAIPanel", true);
            this.$nextTick(() => {
                this.$bus.$emit("showAgreement", true);
            });
        }

        get dbAndTable() {
            return this.$store.state.ui.selectLibrary;
        }
        get libClickObj() {
            return this.$store.state.ui.libClickObj;
        }
        toAidraw() {
            if (this.agreePlus || this.readLocal()) {
            } else {
                this.handleShowAgreement();
                return;
            }
            let list = this.$store.state.library.publicLibraryData;
            let lib = list.find((item) => item.id == this.dbAndTable[2]);
            let shape = lib.data.find((item) => item.table_index == this.libClickObj.clickIndex);
            if (lib && shape && shape.blob) {
                const str = `${lib[this.lang] || lib["en"]}, ${shape[this.lang + "_name"] || shape["en_name"]}`;
                blobToBase64(shape.blob).then((base64) => {
                    this.$store.commit("setDialogState", {
                        type: "dialogType",
                        data: "AIDraw",
                    });
                    this.$store.commit("setDialogState", {
                        type: "showDialog",
                        data: true,
                    });
                    this.$nextTick(() => {
                        this.$bus.$emit("setAidrawOption", {
                            menu: 1,
                            style: 0,
                            image: base64,
                            text: str,
                        });
                    });
                    this.sensors.track("openAiDrawingWindow", {
                        Catalogues: "AiDrawing",
                        open_way: "generateSimilarSymbols",
                        similar_library_name: lib["en"],
                        similar_symbol_name: shape["en_name"],
                        search_symbol_content: "unknown",
                    });
                });
            }
        }

        mounted() {
            this.checkPoint();
            // this.scrollHeightFit();
            this.$bus.$on("closeFeedback", this.closeFeedback);
            this.$bus.$on("toggleFeedback", this.toggleFeedback);
            this.$bus.$on("showAgreement", this.agreeListen);
            this.$bus.$on("aiFeedback", this.aiFeedback);
            window.addEventListener("keydown", this.handleKeydown);
            this.$bus.$on("appVisible", this.refreshAiPoint);
            this.$bus.$on("refreshAIPoint", this.refreshAiPoint);
            window.addEventListener("resize", this.resizeDropdown);
        }
        beforeDestroy() {
            this.$bus.$off("closeFeedback", this.closeFeedback);
            this.$bus.$off("toggleFeedback", this.toggleFeedback);
            this.$bus.$off("showAgreement", this.agreeListen);
            this.$bus.$off("aiFeedback", this.aiFeedback);
            window.removeEventListener("keydown", this.handleKeydown);
            this.$bus.$off("appVisible", this.refreshAiPoint);
            this.$bus.$off("refreshAIPoint", this.refreshAiPoint);
            window.removeEventListener("resize", this.resizeDropdown);
        }
    }
</script>
<i18n>
{
    "zh": {
        "explainthisfile": "分析这个文件",
        "analyzePicture": "分析图片",
        "overTextLength": "字数超出限制",
        "ToNavigate":"切换",
        "selectMode": "选择",
        "canDragPicture": "只允许拖拽图片",
        "uploadImgLimit": "上传图片数量不应超过3个",
        "uploadRightFileType": "请上传正确的文件格式",
        "uploadImgOverSize": "图片大小不能超过20M",
        "inputTitle": "换一换",
        "tcaseTitle1": "热门图形",
        "tcaseTitle2": "市场分析",
        "tcaseTitle3": "用户分析",
        "tcaseDescript1": "流程图、思维导图、表格、列表、时间线",
        "tcaseDescript2": "SWOT分析、PEST分析、精益画布",
        "tcaseDescript3": "用户画像、用户故事",
        "placeholder": "输入你的问题，按Enter键发送消息，按“/”可以切换模式",
        "toolboxStr": "一键制图",
        "chat": "AI 对话",
        "diagram": "AI 制图",
        "aiAnalysis": "AI 分析",
        "pictureAnalysis": "图片分析",
        "documentAnalysis": "文件分析",
        "textAnalysis": "文本分析",

        "chart": "AI 图表",
        "other": "其他",

        "line": "折线图",
        "bar": "柱状图",
        "pie": "饼图",
        "scatter": "散点图",
        "candlestick": "K线图",
        "radar": "雷达图",
        "boxplot": "盒须图",
        "heatmap": "热力图",
        "graphChart": "关系图",
        "sunburst": "旭日图",
        "parallel": "平行坐标系",
        "sankey": "桑基图",
        "funnel": "漏斗图",
        "gauge": "仪表盘",
        
        "timeline": "时间线",
        "list": "列表",
        "table": "表格",
        "mindmap": "思维导图",
        "flowchart": "流程图",
        "canvas": "精益画布",
        "pest": "PEST分析",
        "swot": "SWOT分析",
        "story": "用户故事",
        "portrait": "用户画像",
        "inputNotNull": "消息不可为空",
        "talkOpen-new": "连续问答已开启，接下来亿图AI的回复会基于功能开启后的所有问答内容。",
        "talkOpen": "连续问答已开启，接下来亿图AI的回复会基于功能开启后的所有问答内容。AI点数消耗的速度也会加快~",
        "talkClose": "连续对话已关闭，目前亿图AI仅会对单次消息进行回复",
        "quit": "停止生成",
        "talk": "开启连续对话",
        "stopTalk": "关闭连续对话",
        "clearChat": "清除对话",
        "uploadFile": "上传文件",
        "uploadPicture": "上传图片",
        "replaceFile": "替换文件",
        "send": "发送",
        "likeFeedback": "感谢点赞，我们会继续努力的～",
        "unlikeFeedback": "感谢反馈，我们会认真对待的～",
        "ganttTotal": "项目概述",
        "ganttProgress": "项目进展",
        "ganttRisk": "风险识别",
        "ganttShare": "项目经验分享",
        "analysis": "组织分析",
        "check": "组织诊断",
        "compare": "数据对比",
        "error": "异常识别",
        "summarize": "概括总结",
        "trend": "趋势预测",
        "preset-tag-1": "亿图AI可以做什么?",
        "preset-tag-2": "亿图图示可以做什么?",
        "preset-tag-3": "亿图学堂包含哪些课程?",
        "preset-tag-4": "如何使用亿图AI进行分析?",
        "preset-tag-5": "产品经理的工作职责。",
        "preset-tag-6": "如何做竞品调研?",
        "preset-tag-7": "商业分析一般使用什么模型?",
        "preset-tag-8": "工作周报模板。",
        "preset-tag-9": "SWOT/AARRR的含义是什么?",
        "preset-tag-10": "一份营销活动计划。",
        "preset-tag-11": "一份国庆七天新疆旅游计划",
        "preset-tag-12": "如何筹备婚礼?",
        "preset-tag-13": "设计一款游戏。",
        "preset-tag-14": "一段生日祝福。",
        "file-null": "文件内容为空，请重新选择文件",
        "file-error": "网络出错啦，请重试。",
        "file-format": "该文件无法识别",
        "createFlowChart":"创建流程图",
        "picture": "图片分析",
        "uploadDataToChart": "上传数据绘制图表",
        "createFlowChart":"创建流程图。",
        "picture": "图片分析。",
        "uploadDataToChart": "上传数据绘制图表。",
        "pointToast": "AI智能助手已完成本次指令，消耗了%used%点AI点数",
        "aiTitle": "亿图AI",
        "pointBuy": "点数充值",
        "uploadEchart": "数据图表可视化"
    },
    "en": {
        "explainthisfile": "Analyze this content",
        "analyzePicture": "Analyze this picture",
        "overTextLength": "Exceeded the maximum word limit.",
        "ToNavigate":"To navigate",
        "selectMode": "Select",
        "canDragPicture": "Only images can be dragged in.",
        "uploadImgLimit": "The number of uploaded images should not exceed 3.",
        "uploadRightFileType": "Please upload the correct file format.",
        "uploadImgOverSize": "The size of the image cannot exceed 20MB.",
        "inputTitle": "Try More",
        "tcaseTitle1": "Popular Charts",
        "tcaseTitle2": "Market Analysis",
        "tcaseTitle3": "User Analysis",
        "tcaseDescript1": "flowchart、mind map、table、list、timeline",
        "tcaseDescript2": "SWOT analysis、PEST analysis、lean canvas",
        "tcaseDescript3": "user story、user profile",
        "placeholder": "Ask your question, or enter “/“ change bot",
        "toolboxStr": "AI Diagramming",

        "chat": "AI Chat",
        "diagram": "AI Diagram",
        "aiAnalysis": "AI Analysis",
        "pictureAnalysis": "Picture Analysis",
        "documentAnalysis": "Document Analysis",
        "textAnalysis": "Text Analysis",
        "chart": "AI Chart",
        "other": "Other",

        "line": "Line Chart",
        "bar": "Bar Chart",
        "pie": "Pie Chart",
        "scatter": "Scatter Plot",
        "candlestick": "Candlestick Chart",
        "radar": "Radar Chart",
        "boxplot": "Box Plot",
        "heatmap": "Heat Map",
        "graphChart": "Relational Graph",
        "sunburst": "Sunburst Chart",
        "parallel": "Parallel Coordinates",
        "sankey": "Sankey Diagram",
        "funnel": "Funnel Chart",
        "gauge": "Dial",

        "timeline": "Timeline",
        "list": "List",
        "table": "Table",
        "mindmap": "Mind Map",
        "flowchart": "Flowchart",
        "canvas": "Lean Canvas",
        "pest": "PEST Analysis",
        "swot": "SWOT Analysis",
        "story": "User Story",
        "portrait": "User Profile",
        "inputNotNull": "cannot be empty",
        "talkOpen-new": "The continuous Q&A feature has been enabled. Edraw AI will now give answers based on the Q&A content.",
        "talkOpen": "The continuous Q&A feature has been enabled. Edraw AI will now give answers based on the Q&A content. Your AI credits will also be used up quicker.",
        "talkClose": "The continuous Q&A feature has been disabled. Now Edraw AI can only reply to one message at a time.",
        "quit": "Stop generating",
        "talk": "Turn on Continued Conversation",
        "stopTalk": "Turn off Continued Conversation",
        "clearChat": "Clear Chat",
        "uploadFile": "Upload file",
        "uploadPicture": "Upload picture",
        "replaceFile": "Replace file",
        "send": "Send",
        "likeFeedback": "Thank you for liking us. We will try to do even better!",
        "unlikeFeedback": "Thank you for your feedback. We'll improve on that.",
        "ganttTotal": "Project Overview",
        "ganttProgress": "Project Progress",
        "ganttRisk": "Risk Identification",
        "ganttShare": "Lessons Learned",
        "analysis": "Organization Analysis",
        "check": "Organization Diagnosis",
        "compare": "Data Comparison",
        "error": "Anomaly Identification",
        "summarize": "Summary",
        "trend": "Trends Prediction",
        "preset-tag-1": "What can Edraw AI do?",
        "preset-tag-2": "What can EdrawMax do?",
        "preset-tag-3": "What courses does Edraw Course include?",
        "preset-tag-4": "How do I use Edraw AI for analysis?",
        "preset-tag-5": "Responsibilities of a product manager",
        "preset-tag-6": "How do I carry out competitor research?",
        "preset-tag-7": "What models are generally used for business analysis?",
        "preset-tag-8": "Weekly work report template.",
        "preset-tag-9": "What do SWOT and AARRR stand for?",
        "preset-tag-10": "A marketing campaign plan.",
        "preset-tag-11": "A week-long travel plan for Xinjiang during the national holidays.",
        "preset-tag-12": "How can I plan my wedding?",
        "preset-tag-13": "Design a game.",
        "preset-tag-14": "Birthday wishes.",
        "file-null": "The file is empty. Please select again.",
        "file-error": "Network error. Please try again.",
        "file-format": "The file cannot be recognized.",
        "createFlowChart":"Create a flowchart",
        "picture": "Analyze an picture",
        "uploadDataToChart": "Upload data to chart",
        "createFlowChart":"Create a flowchart.",
        "picture": "Analyze a picture.",
        "uploadDataToChart": "Upload data to create chart.",
        "pointToast": "The AI smart assistant has followed the instruction and used %used% AI points",
        "aiTitle": "Edraw AI",
        "pointBuy": "Top up your credits",
        "uploadEchart": "Visualize this dataset"
    },
    "fr": {
        "explainthisfile": "Expliquez ce fichier",
        "analyzePicture": "Analysez cette image",
        "overTextLength": "Vous avez dépassé la limite maximale de mots.",
        "ToNavigate":"Pour naviguer",
        "selectMode": "Sélectionner",
        "canDragPicture": "Seules les images peuvent être glissées.",
        "uploadImgLimit": "Le nombre d'images téléchargées ne doit pas dépasser 3.",
        "uploadRightFileType": "Veuillez télécharger le bon format de fichier.",
        "uploadImgOverSize": "La taille de l'image ne peut pas dépasser 20MB.",
        "inputTitle": "Essayer encore",
        "tcaseTitle1": "Graphiques populaires",
        "tcaseTitle2": "Analyse de marché",
        "tcaseTitle3": "Analyse des utilisateurs",
        "tcaseDescript1": "Organigramme、Carte mentale、Tableau、Liste、Chronologie",
        "tcaseDescript2": "Analyse SWOT、Analyse PEST、Lean canvas",
        "tcaseDescript3": "Profil utilisateur、Récit utilisateur",
        "placeholder": "Posez votre question ou saisissez « / » pour changer de bot.",
        "toolboxStr": "Tracé AI en un clic",
        "chat": "Chat AI",
        "diagram": "Diagramme IA",
        "aiAnalysis": "AI Analysis",
        "pictureAnalysis": "Analyse d'image",
        "documentAnalysis": "Analyse de documents",
        "textAnalysis": "Analyse de texte",
        "chart": "Graphique IA",
        "other": "Autre",

        "line": "Graphiques en courbes",
        "bar": "Graphiques à barres",
        "pie": "Graphiques en secteurs",
        "scatter": "Nuage de points",
        "candlestick": "Graphique en chandeliers",
        "radar": "Graphique en radar",
        "boxplot": "Diagramme en boîte",
        "heatmap": "Carte thermique",
        "graphChart": "Graphique relationnel",
        "sunburst": "Graphique en rayons de soleil",
        "parallel": "Coordonnées parallèles",
        "sankey": "Diagramme Sankey",
        "funnel": "Graphique en entonnoir",
        "gauge": "Cadran",

        "timeline": "Chronologie",
        "list": "Liste",
        "table": "Tableau",
        "mindmap": "Carte mentale",
        "flowchart": "Organigramme",
        "canvas": "Lean canvas",
        "pest": "Analyse PEST",
        "swot": "Analyse SWOT",
        "story": "Récit utilisateur",
        "portrait": "Profil utilisateur",
        "inputNotNull": "Le texte ne peut pas être vide.",
        "talkOpen-new": "La fonction de questions/réponses en continu a été activée. Edraw AI donnera désormais des réponses basées sur le contenu des questions/réponses.",
        "talkOpen": "La fonction de questions/réponses en continu a été activée. Edraw AI donnera désormais des réponses basées sur le contenu des questions/réponses. Vos crédits d'IA seront également consommés plus rapidement.",
        "talkClose": "La fonction de questions/réponses en continu a été désactivée. Désormais, Edraw AI ne peut répondre qu'à un seul message à la fois.",
        "quit": "Arrêter la génération",
        "talk": "Activer la conversation continue",
        "clearChat": "Effacer le chat",
        "stopTalk": "Désactiver la conversation continue",
        "uploadFile": "Charger un fichier",
        "uploadPicture": "上传图片",
        "replaceFile": "Remplacer le fichier",
        "send": "Envoyer",
        "likeFeedback": "Merci d'apprécier notre travail. Nous tâcherons de faire encore mieux !",
        "unlikeFeedback": "Merci pour vos commentaires. Nous nous en servirons pour nous améliorer.",
        "ganttTotal": "Aperçu du projet",
        "ganttProgress": "Avancement du projet",
        "ganttRisk": "Identificación de riesgos",
        "ganttShare": "Leçons apprises",
        "analysis": "Analyse d'organisation",
        "check": "Diagnostic d'organisation",
        "compare": "Comparaison des données",
        "error": "Identification des anomalies",
        "summarize": "Résumé",
        "trend": "Prédiction des tendances",
        "preset-tag-1": "Que peut faire la fonction IA d'Edraw ?",
        "preset-tag-2": "Que peut faire EdrawMax ?",
        "preset-tag-3": "Quels sont les cours inclus dans Edraw Course ?",
        "preset-tag-4": "Comment utiliser la fonction IA d'Edraw pour l'analyse ?",
        "preset-tag-5": "Responsabilités d'un chef de produit.",
        "preset-tag-6": "Comment effectuer des recherches sur la concurrence ?",
        "preset-tag-7": "Quels modèles sont généralement utilisés pour l'analyse commerciale ?",
        "preset-tag-8": "Modèle de rapport de travail hebdomadaire.",
        "preset-tag-9": "Que signifient SWOT et AARRR ?",
        "preset-tag-10": "Un plan de campagne marketing.",
        "preset-tag-11": "Un projet de voyage d'une semaine au Xinjiang pendant les fêtes nationales.",
        "preset-tag-12": "Comment organiser mon mariage ?",
        "preset-tag-13": "Concevoir un jeu.",
        "preset-tag-14": "Vœux d'anniversaire.",
        "file-null": "The file is empty. Please select again.",
        "file-error": "Erreur réseau. Réessayez.",
        "file-format": "Ce fichier ne peut pas être reconnu.",
        "createFlowChart":"Créer un organigramme.",
        "picture": "Analyser une image.",
        "uploadDataToChart": "Charger des données pour créer un graphique.",
        "pointToast": "L'assistant IA a suivi les instructions et utilisé %used% points IA",
        "aiTitle": "IA Edraw",
        "pointBuy": "Compléter vos crédits",
        "uploadEchart": "Visualisez cet ensemble de données"
    },
    "de": {
        "explainthisfile": "Erklären Sie diese Datei",
        "analyzePicture": "Analysieren Sie dieses Bild",
        "overTextLength": "Die maximale Wortanzahl wurde überschritten.",
        "ToNavigate":"Zur Navigation",
        "selectMode": "Auswählen",
        "canDragPicture": "Nur Bilder können hereingezogen werden.",
        "uploadImgLimit": "Die Anzahl der hochgeladenen Bilder sollte 3 nicht überschreiten.",
        "uploadRightFileType": "Bitte laden Sie das korrekte Dateiformat hoch.",
        "uploadImgOverSize": "Die Größe des Bildes darf 20MB nicht überschreiten.",
        "inputTitle": "Weiteres ausprobieren",
        "tcaseTitle1": "Beliebte Diagramme",
        "tcaseTitle2": "Marktanalyse",
        "tcaseTitle3": "Benutzeranalyse",
        "tcaseDescript1": "Flussdiagramm、Mindmap、Tabelle、Liste、Zeitachse",
        "tcaseDescript2": "SWOT-Analyse、STEP-Analyse、Lean Canvas",
        "tcaseDescript3": "Benutzerprofil、User Story",
        "placeholder": "Stellen Sie Ihre Frage oder geben Sie „/“ ein, um den Bot zu ändern",
        "toolboxStr": "AI Plotting",
        "chat": "AI Chat",
        "diagram": "KI-Diagramm",
        "aiAnalysis": "AI Analysis",
        "pictureAnalysis": "Bildanalyse",
        "documentAnalysis": "Dokumentanalyse",
        "textAnalysis": "Textanalyse",
        "chart": "KI-Diagramm",
        "other": "Andere",

        "line": "Liniendiagramme",
        "bar": "Balkendiagramme",
        "pie": "Kreisdiagramme",
        "scatter": "Streudiagramm",
        "candlestick": "Kerzendiagramm",
        "radar": "Netzdiagramm",
        "boxplot": "Kastendiagramm",
        "heatmap": "Wärmebild",
        "graphChart": "Relationsdiagramm",
        "sunburst": "Sunburst-Diagramm",
        "parallel": "Parallele Koordinaten",
        "sankey": "Sankey-Diagramm",
        "funnel": "Trichterdiagramm",
        "gauge": "Zifferblatt",

        "timeline": "Zeitachse",
        "list": "Liste",
        "table": "Tabelle",
        "mindmap": "Mindmap",
        "flowchart": "Flussdiagramm",
        "canvas": "Lean Canvas",
        "pest": "STEP-Analyse",
        "swot": "SWOT-Analyse",
        "story": "User Story",
        "portrait": "Benutzerprofil",
        "inputNotNull": "Das Textfeld darf nicht leer sein",
        "talkOpen-new": "Die Funktion für fortlaufende Fragen und Antworten wurde aktiviert. Edraw AI gibt nun Rückmeldungen auf Basis der Fragen und Antworten.",
        "talkOpen": "Die Funktion für fortlaufende Fragen und Antworten wurde aktiviert. Edraw AI gibt nun Rückmeldungen auf Basis der Fragen und Antworten. Ihr KI-Guthaben wird zudem schneller aufgebraucht.",
        "talkClose": "Die Funktion für fortlaufende Fragen und Antworten wurde deaktiviert. Jetzt kann Edraw AI nur auf eine Nachricht nach der anderen antworten.",
        "quit": "Generierung beenden",
        "talk": "Fortlaufende Konversation aktivieren",
        "clearChat": "Chat löschen",
        "stopTalk": "Fortlaufende Konversation deaktivieren",
        "uploadFile": "Datei hochladen",
        "uploadPicture": "上传图片",
        "replaceFile": "Datei ersetzen",
        "send": "Senden",
        "likeFeedback": "Schön, dass es Ihnen gefällt. Wir bemühen uns, uns zu verbessern!",
        "unlikeFeedback": "Vielen Dank für Ihr Feedback. Das werden wir verbessern.",
        "ganttTotal": "Projektübersicht",
        "ganttProgress": "Projektfortschritt",
        "ganttRisk": "Risikoermittlung",
        "ganttShare": "Gesammelte Erfahrungen",
        "analysis": "Organisationsanalyse",
        "check": "Organisationsdiagnose",
        "compare": "Datenvergleich",
        "error": "Erkennung von Anomalien",
        "summarize": "Zusammenfassung",
        "trend": "Trendvorhersage",
        "preset-tag-1": "Was kann Edraw AI?",
        "preset-tag-2": "Was kann EdrawMax?",
        "preset-tag-3": "Welche Kurse umfasst Edraw Course?",
        "preset-tag-4": "Wie verwende ich Edraw AI für Analysen?",
        "preset-tag-5": "Verantwortlichkeiten eines Produktmanagers.",
        "preset-tag-6": "Wie führe ich eine Mitbewerber-Recherche durch?",
        "preset-tag-7": "Welche Modelle werden im Allgemeinen für Geschäftsanalysen verwendet?",
        "preset-tag-8": "Vorlage für wöchentliche Arbeitsberichte.",
        "preset-tag-9": "Wofür stehen SWOT und AARRR?",
        "preset-tag-10": "Ein Plan für eine Marketingkampagne.",
        "preset-tag-11": "Ein einwöchiger Reiseplan für Xinjiang während der nationalen Feiertage.",
        "preset-tag-12": "Wie kann ich meine Hochzeit planen?",
        "preset-tag-13": "Ein Spiel entwerfen.",
        "preset-tag-14": "Geburtstagswünsche.",
        "file-null": "The file is empty. Please select again.",
        "file-error": "Netzwerkfehler. Versuchen Sie es erneut.",
        "file-format": "Diese Datei kann nicht erkannt werden.",
        "createFlowChart":"Ein Flussdiagramm erstellen.",
        "picture": "Ein Bild analysieren.",
        "uploadDataToChart": "Daten hochladen, um ein Diagramm zu erstellen.",
        "pointToast": "AI Smart Assistant hat die Anweisung ausgeführt und dafür %used% AI-Punkte verwendet",
        "aiTitle": "Edraw AI",
        "pointBuy": "Guthaben auffüllen",
        "uploadEchart": "Visualisieren Sie diesen Datensatz"
    },
    "jp": {
        "explainthisfile": "このファイルを説明してください",
        "analyzePicture": "この画像を分析してください",
        "overTextLength": "最大単語数を超えました。",
        "ToNavigate":"ナビゲートするには",
        "selectMode": "選択",
        "canDragPicture": "画像のみをドラッグできます。",
        "uploadImgLimit": "アップロードされた画像の数は3を超えてはなりません。",
        "uploadRightFileType": "正しいファイル形式をアップロードしてください。",
        "uploadImgOverSize": "画像のサイズは20MBを超えることはできません。",
        "inputTitle": "もっと試す",
        "tcaseTitle1": "よく使うチャート",
        "tcaseTitle2": "市場分析",
        "tcaseTitle3": "ユーザー分析",
        "tcaseDescript1": "フローチャート、マインドマップ、テーブル、リスト、タイムライン",
        "tcaseDescript2": "SWOT分析、PEST分析、リーンキャンバス",
        "tcaseDescript3": "ユーザープロファイル、ユーザーストーリー",
        "placeholder": "質問をするか、ボットを変更する場合は「/」と入力します",
        "toolboxStr": "AI作図",
        "chat": "AIチャット",
        "diagram": "AI ダイアグラム",
        "aiAnalysis": "AI Analysis",
        "pictureAnalysis": "画像解析",
        "documentAnalysis": "ドキュメント解析",
        "textAnalysis": "テキスト分析",
        "chart": "AI チャート",
        "other": "その他",

        "line": "折れ線グラフ",
        "bar": "棒グラフ",
        "pie": "円グラフ",
        "scatter": "散布図",
        "candlestick": "ローソク足チャート",
        "radar": "レーダーチャート",
        "boxplot": "箱ひげ図",
        "heatmap": "ヒートマップ",
        "graphChart": "関係グラフ",
        "sunburst": "サンバースト図",
        "parallel": "平行座標",
        "sankey": "サンキーダイアグラム",
        "funnel": "じょうごグラフ",
        "gauge": "ダイヤル",

        "timeline": "タイムライン",
        "list": "リスト",
        "table": "テーブル",
        "mindmap": "マインドマップ",
        "flowchart": "フローチャート",
        "canvas": "リーンキャンバス",
        "pest": "PEST分析",
        "swot": "SWOT分析",
        "story": "ユーザーストーリー",
        "portrait": "ユーザープロファイル",
        "inputNotNull": "テキストは空白にできません",
        "talkOpen-new": "連続Q&A機能が有効です。Edraw AIがQ&Aの内容に基づいて回答します。",
        "talkOpen": "連続Q&A機能が有効です。Edraw AIがQ&Aの内容に基づいて回答します。AIクレジットの消費が早くなります。",
        "talkClose": "連続Q&A機能が無効です。Edraw AIは一度に1つのメッセージにのみ回答できます。",
        "quit": "生成を停止",
        "talk": "会話を継続をオン",
        "clearChat": "チャットをクリア",
        "stopTalk": "会話を継続をオフ",
        "uploadFile": "ファイルをアップロード",
        "uploadPicture": "上传图片",
        "replaceFile": "ファイルを置換",
        "send": "送信",
        "likeFeedback": "気に入っていただき、ありがとうございます。次回は、さらに期待に応えられるようにします！",
        "unlikeFeedback": "フィードバックをありがとうございます。ご意見をもとに、改善に努めてまいります。",
        "ganttTotal": "プロジェクトの概要",
        "ganttProgress": "プロジェクトの進行状況",
        "ganttRisk": "リスクの特定",
        "ganttShare": "得られた経験",
        "analysis": "組織分析",
        "check": "組織診断",
        "compare": "データ比較",
        "error": "異常の特定",
        "summarize": "まとめ",
        "trend": "トレンド予測",
        "preset-tag-1": "Edraw AIで何ができますか？",
        "preset-tag-2": "EdrawMaxで何ができますか？",
        "preset-tag-3": "Edrawコースにはどのようなコースが含まれますか？",
        "preset-tag-4": "解析にEdraw AIを使用する方法を教えてください。",
        "preset-tag-5": "製品マネージャーの責任。",
        "preset-tag-6": "競合企業の調査を実施する方法を教えてください。",
        "preset-tag-7": "ビジネス分析に一般的に使用されるモデルは何ですか？",
        "preset-tag-8": "週次作業レポートテンプレート。",
        "preset-tag-9": "SWOTとAARRRは何の略ですか？",
        "preset-tag-10": "マーケティングキャンペーン計画。",
        "preset-tag-11": "祝日中に新疆に行く1週間の旅行計画。",
        "preset-tag-12": "自分の結婚式を計画するには？",
        "preset-tag-13": "ゲームのデザイン。",
        "preset-tag-14": "誕生日祝いの言葉。",
        "file-null": "The file is empty. Please select again.",
        "file-error": "ネットワークエラーです。もう一度お試しください。",
        "file-format": "このファイルは認識できません。",
        "createFlowChart":"フローチャート作成。",
        "picture": "画像解析。",
        "uploadDataToChart": "アップロードしたデータでチャート作成。",
        "pointToast": "AIスマートアシスタントは指示に従い、%used%AIポイントを使用しました",
        "aiTitle": "Edraw AI",
        "pointBuy": "クレジットを補充",
        "uploadEchart": "このデータセットを視覚化する"
    },
    "es": {
        "explainthisfile": "Explique este archivo",
        "analyzePicture": "Analiza esta imagen",
        "overTextLength": "Se ha superado el límite máximo de palabras.",
        "ToNavigate":"Para navegar",
        "selectMode": "Seleccionar",
        "canDragPicture": "Solo se pueden arrastrar imágenes.",
        "uploadImgLimit": "El número de imágenes cargadas no debe superar las 3.",
        "uploadRightFileType": "Por favor, suba el formato de archivo correcto.",
        "uploadImgOverSize": "El tamaño de la imagen no puede exceder los 20MB.",
        "inputTitle": "Prueba más",
        "tcaseTitle1": "Gráficos populares",
        "tcaseTitle2": "Análisis de mercado",
        "tcaseTitle3": "Análisis de usuarios",
        "tcaseDescript1": "Diagrama de flujo、Mapa mental、Tabla、Lista、Línea de tiempo",
        "tcaseDescript2": "Análisis DAFO、Análisis PEST、Lienzo en blanco",
        "tcaseDescript3": "Perfil de usuario、Historia de usuario",
        "placeholder": "Formula la pregunta o introduce '/' para modificar el bot",
        "toolboxStr": "Trazado de AI",
        "chat": "Chat de AI",
        "diagram": "Diagrama de IA",
        "aiAnalysis": "AI Analysis",
        "pictureAnalysis": "Análisis de imágenes",
        "documentAnalysis": "Análisis de documentos",
        "textAnalysis": "Análisis de texto",
        "chart": "Gráfico IA",
        "other": "Otro",

        "line": "Gráficos de líneas",
        "bar": "Gráficos de barras",
        "pie": "Gráficos circulares",
        "scatter": "Diagrama de dispersión",
        "candlestick": "Gráfico candelabro",
        "radar": "Gráfico radial",
        "boxplot": "Diagrama de caja",
        "heatmap": "Mapa térmico",
        "graphChart": "Gráfico relacional",
        "sunburst": "Gráfico de proyección solar",
        "parallel": "Coordenadas paralelas",
        "sankey": "Diagrama de Sankey",
        "funnel": "Gráfico de embudo",
        "gauge": "Dial",

        "timeline": "Línea de tiempo",
        "list": "Lista",
        "table": "Tabla",
        "mindmap": "Mapa mental",
        "flowchart": "Diagrama de flujo",
        "canvas": "Lienzo en blanco",
        "pest": "Análisis PEST",
        "swot": "Análisis DAFO",
        "story": "Historia de usuario",
        "portrait": "Perfil de usuario",
        "inputNotNull": "El texto no puede estar vacío",
        "talkOpen-new": "Se ha activado la función de preguntas y respuestas continuas. La IA de Edraw ofrecerá respuestas basadas en el contenido de las preguntas y respuestas.",
        "talkOpen": "Se ha activado la función de preguntas y respuestas continuas. La IA de Edraw ofrecerá respuestas basadas en el contenido de las preguntas y respuestas. También se agotarán antes tus créditos de IA.",
        "talkClose": "Se ha desactivado la función de preguntas y respuestas continuas. la IA de Edraw solo podrá responder a un mensaje cada vez.",
        "quit": "Detener generación",
        "talk": "Activar la conversación continua",
        "clearChat": "Borrar chat",
        "stopTalk": "Desactivar la conversación continua",
        "uploadFile": "Cargar archivo",
        "uploadPicture": "上传图片",
        "replaceFile": "Reemplazar archivo",
        "send": "Enviar",
        "likeFeedback": "Gracias por indicar que te gustamos. ¡Intentaremos hacerlo aún mejor!",
        "unlikeFeedback": "Gracias por tus comentarios. Vamos a mejorarlo.",
        "ganttTotal": "Descripción general del proyecto",
        "ganttProgress": "Progreso del proyecto",
        "ganttRisk": "Identificación de riesgos",
        "ganttShare": "Lecciones aprendidas",
        "analysis": "Análisis de organización",
        "check": "Diagnóstico de organización",
        "compare": "Comparación de datos",
        "error": "Identificación de anomalías",
        "summarize": "Resumen",
        "trend": "Predicción de tendencias",
        "preset-tag-1": "¿Qué puede hacer Edraw AI?",
        "preset-tag-2": "¿Qué puede hacer EdrawMax?",
        "preset-tag-3": "¿Qué cursos se incluyen en Cursos de Edraw?",
        "preset-tag-4": "¿Cómo utilizo Edraw AI para análisis?",
        "preset-tag-5": "Responsabilidades de un responsable de productos.",
        "preset-tag-6": "¿Cómo puedo llevar a cabo una investigación de la competencia?",
        "preset-tag-7": "¿Qué modelos se suelen utilizar para el análisis empresarial?",
        "preset-tag-8": "Plantilla de informe de trabajo semanal.",
        "preset-tag-9": "¿Qué significan DAFO y AARRR?",
        "preset-tag-10": "Un plan de campaña de marketing.",
        "preset-tag-11": "Un plan de viaje de una semana a Xinjiang durante las fiestas nacionales.",
        "preset-tag-12": "¿Cómo puedo planificar mi boda?",
        "preset-tag-13": "Diseñe un juego.",
        "preset-tag-14": "Felicitaciones de cumpleaños.",
        "file-null": "The file is empty. Please select again.",
        "file-error": "Error de red. Vuelva a intentarlo.",
        "file-format": "Este archivo no puede ser reconocido.",
        "createFlowChart":"Crear un diagrama de flujo.",
        "picture": "Analizar una imagen.",
        "uploadDataToChart": "Cargar datos para crear gráfico.",
        "pointToast": "El asistente inteligente de IA ha seguido la instrucción y ha utilizado %used% puntos de IA",
        "aiTitle": "IA de Edraw",
        "pointBuy": "Recarga tus créditos",
        "uploadEchart": "Visualiza este conjunto de datos"
    },
    "pt": {
        "explainthisfile": "Explique este arquivo",
        "analyzePicture": "Analise esta imagem",
        "overTextLength": "Excedeu o limite máximo de palavras.",
        "ToNavigate":"Para navegar",
        "selectMode": "Selecionar",
        "canDragPicture": "Apenas imagens podem ser arrastadas para dentro.",
        "uploadImgLimit": "O número de imagens carregadas não deve exceder 3.",
        "uploadRightFileType": "Por favor, faça o upload do formato de arquivo correto.",
        "uploadImgOverSize": "O tamanho da imagem não pode exceder 20MB.",
        "inputTitle": "Experimente mais",
        "tcaseTitle1": "Gráficos populares",
        "tcaseTitle2": "Análise de mercado",
        "tcaseTitle3": "Análise de usuário",
        "tcaseDescript1": "Fluxograma、Mapa mental、Tabela、Lista、Linha do tempo",
        "tcaseDescript2": "Análise SWOT、Análise PEST、Lean Canvas",
        "tcaseDescript3": "Perfil do usuário、História do usuário",
        "placeholder": "Faça sua pergunta ou insira '/' para alterar o bot",
        "toolboxStr": "Diagramação por IA",
        "chat": "Chat por IA",
        "diagram": "Diagrama de IA",
        "aiAnalysis": "AI Analysis",
        "pictureAnalysis": "Análise de imagem",
        "documentAnalysis": "Análise de documento",
        "textAnalysis": "Análise de texto",
        "chart": "Gráfico de IA",
        "other": "Outro",

        "line": "Gráficos de linha",
        "bar": "Gráfico de barras",
        "pie": "Gráficos de pizza",
        "scatter": "Dispersão",
        "candlestick": "Gráfico de castiçal",
        "radar": "Gráfico de radar",
        "boxplot": "Diagrama em caixa",
        "heatmap": "Mapa de calor",
        "graphChart": "Gráfico relacional",
        "sunburst": "Gráfico de explosão solar",
        "parallel": "Coordenadas paralelas",
        "sankey": "Diagrama de Sankey",
        "funnel": "Gráfico de funil",
        "gauge": "Marcação",
        "timeline": "Linha do tempo",
        "list": "Lista",
        "table": "Tabela",
        "mindmap": "Mapa mental",
        "flowchart": "Fluxograma",
        "canvas": "Lean Canvas",
        "pest": "Análise PEST",
        "swot": "Análise SWOT",
        "story": "História do usuário",
        "portrait": "Perfil do usuário",
        "inputNotNull": "O campo de texto não pode ficar vazio",
        "talkOpen-new": "O recurso de perguntas e respostas contínuas foi habilitado. Agora, o Edraw AI fornece respostas com base no conteúdo das perguntas e respostas.",
        "talkOpen": "O recurso de perguntas e respostas contínuas foi habilitado. Agora, o Edraw AI fornece respostas com base no conteúdo das perguntas e respostas. Seus créditos de IA também terminarão mais rápido.",
        "talkClose": "O recurso de perguntas e respostas contínuo foi desabilitado. Agora, o Edraw AI só pode responder a uma mensagem de cada vez.",
        "quit": "Parar geração",
        "talk": "Ativar conversa contínua",
        "clearChat": "Limpar conversa",
        "stopTalk": "Desativar conversa contínua",
        "uploadFile": "Carregar arquivo",
        "uploadPicture": "上传图片",
        "replaceFile": "Substituir arquivo",
        "send": "Enviar",
        "likeFeedback": "Legal que você curtiu. Queremos melhorar sempre!",
        "unlikeFeedback": "Agradecemos seu feedback. Vamos melhorar isso.",
        "ganttTotal": "Visão geral do projeto",
        "ganttProgress": "Progresso do projeto",
        "ganttRisk": "Identificação de risco",
        "ganttShare": "Lições aprendidas",
        "analysis": "Análise da organização",
        "check": "Diagnóstico da organização",
        "compare": "Comparação de dados",
        "error": "Identificação de anomalia",
        "summarize": "Resumo",
        "trend": "Previsão de tendências",
        "preset-tag-1": "O que o Edraw AI pode fazer?",
        "preset-tag-2": "O que o EdrawMax pode fazer?",
        "preset-tag-3": "Quais cursos o Edraw Course inclui?",
        "preset-tag-4": "Como posso usar o Edraw AI para análise?",
        "preset-tag-5": "Responsabilidades de um gerente de produto.",
        "preset-tag-6": "Como realizo uma pesquisa de concorrência?",
        "preset-tag-7": "Quais modelos são geralmente usados para análise de negócios?",
        "preset-tag-8": "Modelo de relatório de trabalho semanal.",
        "preset-tag-9": "O que significa FOFA e AARRR?",
        "preset-tag-10": "Um plano de campanha de marketing.",
        "preset-tag-11": "Um plano de viagem de uma semana para Xinjiang durante os feriados nacionais.",
        "preset-tag-12": "Como posso planejar meu casamento?",
        "preset-tag-13": "Criar um jogo.",
        "preset-tag-14": "Votos de aniversário.",
        "file-null": "The file is empty. Please select again.",
        "file-error": "Erro de rede. Tente novamente.",
        "file-format": "Este arquivo não pode ser reconhecido.",
        "createFlowChart":"Criar um fluxograma.",
        "picture": "Analisar uma imagem.",
        "uploadDataToChart": "Carregar dados para criar gráfico.",
        "pointToast": "O assistente inteligente de IA seguiu as instruções e usou os pontos de IA %used%",
        "aiTitle": "IA do Edraw",
        "pointBuy": "Aumente seus créditos",
        "uploadEchart": "Visualize este conjunto de dados."
    },
    "it": {
        "explainthisfile": "Spiega questo file",
        "analyzePicture": "Analizza questa immagine",
        "overTextLength": "Hai superato il limite massimo di parole.",
        "ToNavigate":"Per navigare",
        "selectMode": "Selezionare",
        "canDragPicture": "Si possono trascinare solo immagini.",
        "uploadImgLimit": "Il numero di immagini caricate non deve superare 3.",
        "uploadRightFileType": "Si prega di caricare il formato di file corretto.",
        "uploadImgOverSize": "La dimensione dell'immagine non può superare i 20MB.",
        "inputTitle": "Prova altro",
        "tcaseTitle1": "Grafici più utilizzati",
        "tcaseTitle2": "Analisi di mercato",
        "tcaseTitle3": "Analisi utente",
        "tcaseDescript1": "Diagramma di flusso、Mappa mentale、Tabella、Elenco、Cronologia",
        "tcaseDescript2": "Analisi SWOT、Analisi PEST、Lean Canvas",
        "tcaseDescript3": "Profilo utente、Storia utente",
        "placeholder": "Rivolgi la tua domanda o inserisci '/' per modificare il bot",
        "toolboxStr": "Tracciamento AI",
        "chat": "Obrolan AI",
        "diagram": "Diagramma IA",
        "aiAnalysis": "AI Analysis",
        "pictureAnalysis": "Analisi immagine",
        "documentAnalysis": "Analisi documento",
        "textAnalysis": "Analisi testo",
        "chart": "Grafico IA",
        "other": "Altro",

        "line": "Grafici a linee",
        "bar": "Grafici a barre",
        "pie": "Grafici a torta",
        "scatter": "Grafico di dispersione",
        "candlestick": "Grafico a candela",
        "radar": "Grafico radar",
        "boxplot": "Box plot",
        "heatmap": "Mappa termica",
        "graphChart": "Diagramma relazionale",
        "sunburst": "Grafico radiale",
        "parallel": "Coordinate parallele",
        "sankey": "Diagramma di Sankey",
        "funnel": "Grafico a imbuto",
        "gauge": "Quadrante",

        "timeline": "Cronologia",
        "list": "Elenco",
        "table": "Tabella",
        "mindmap": "Mappa mentale",
        "flowchart": "Diagramma di flusso",
        "canvas": "Lean Canvas",
        "pest": "Analisi PEST",
        "swot": "Analisi SWOT",
        "story": "Storia utente",
        "portrait": "Profilo utente",
        "inputNotNull": "Il testo non può essere vuota",
        "talkOpen-new": "La funzione continua Domande e risposte è stata attivata. Edraw AI è ora in grado di fornire risposte basate sui contenuti di Domande e risposte.",
        "talkOpen": "La funzione continua Domande e risposte è stata attivata. Edraw AI è ora in grado di fornire risposte basate sui contenuti di Domande e risposte. Anche i tuoi crediti AI verranno utilizzati più velocemente.",
        "talkClose": "La funzione continua Domande e risposte è stata disattivata. Adesso Edraw AI può rispondere a un solo messaggio alla volta.",
        "quit": "Interrompi generazione",
        "talk": "Attiva conversazione continua",
        "clearChat": "Cancella chat",
        "stopTalk": "Disattiva conversazione continua",
        "uploadFile": "Carica file",
        "uploadPicture": "上传图片",
        "replaceFile": "Sostituisci file",
        "send": "Invia",
        "likeFeedback": "Grazie per aver detto che ti piace. Cercheremo di migliorare ancora!",
        "unlikeFeedback": "Grazie per il feedback Ci impegniamo a migliorare.",
        "ganttTotal": "Panoramica del progetto",
        "ganttProgress": "Stato del progetto",
        "ganttRisk": "Identificazione rischio",
        "ganttShare": "Analisi di fine progetto",
        "analysis": "Analisi organizzazione",
        "check": "Diagnosi organizzazione",
        "compare": "Confronto dei dati",
        "error": "Identificazione delle anomalie",
        "summarize": "Riepilogo",
        "trend": "Previsione tendenze",
        "preset-tag-1": "Cosa è in grado di fare Edraw AI?",
        "preset-tag-2": "Cosa è in grado di fare EdrawMax?",
        "preset-tag-3": "Quali corsi include Edraw Course?",
        "preset-tag-4": "Come posso utilizzare Edraw AI per le analisi?",
        "preset-tag-5": "Responsabilità di un Product Manager.",
        "preset-tag-6": "Come faccio a condurre una ricerca sulla concorrenza?",
        "preset-tag-7": "Quali modelli vengono generalmente utilizzati per l'analisi aziendale?",
        "preset-tag-8": "Modello di rapporto di lavoro settimanale.",
        "preset-tag-9": "Cosa significano le sigle SWOT e AARRR?",
        "preset-tag-10": "Piano per una campagna di marketing.",
        "preset-tag-11": "Piano di viaggio di una settimana per Xinjiang durante le festività nazionali.",
        "preset-tag-12": "Come posso pianificare il mio matrimonio?",
        "preset-tag-13": "Progettare un gioco.",
        "preset-tag-14": "Auguri di compleanno.",
        "file-null": "The file is empty. Please select again.",
        "file-error": "Errore di rete. Riprova.",
        "file-format": "Questo file non può essere riconosciuto.",
        "createFlowChart":"Crea un diagramma di flusso.",
        "picture": "Analizza un'immagine.",
        "uploadDataToChart": "Carica i dati per creare il grafico.",
        "pointToast": "L'assistente AI ha seguito l'istruzione e ha utilizzato %used% punti AI",
        "aiTitle": "Edraw AI",
        "pointBuy": "Ricarica i tuoi crediti",
        "uploadEchart": "Visualizza questo set di dati"
    },
    "tw": {
        "explainthisfile": "解釋這個檔案",
        "analyzePicture": "分析這張圖片",
        "overTextLength": "超出了最大字數限制。",
        "ToNavigate":"切換",
        "selectMode": "選擇",
        "canDragPicture": "只能拖曳圖片進來。",
        "uploadImgLimit": "N上傳的圖片數量不應超過3張。",
        "uploadRightFileType": "請上傳正確的檔案格式。",
        "uploadImgOverSize": "圖片的大小不能超過20MB。",
        "inputTitle": "嘗試更多",
        "tcaseTitle1": "熱門圖表",
        "tcaseTitle2": "市場分析",
        "tcaseTitle3": "使用者分析",
        "tcaseDescript1": "流程图、心智圖、表格、清單、時間軸",
        "tcaseDescript2": "SWOT分析、PEST分析、精實畫布",
        "tcaseDescript3": "使用者設定檔、使用者案例",
        "placeholder": "詢問問題，或輸入「/」來變更機器人",
        "toolboxStr": "AI 製圖",
        "chat":  "AI 聊天",
        "diagram": "AI 圖表",
        "aiAnalysis": "AI Analysis",
        "pictureAnalysis": "圖片分析",
        "documentAnalysis": "文件分析",
        "textAnalysis": "文字分析",
        "chart": "AI 圖表",
        "other": "其他",

        "line": "折線圖",
        "bar": "長條圖",
        "pie": "圓形圖",
        "scatter": "散布圖",
        "candlestick": "蠟燭圖",
        "radar": "雷達圖",
        "boxplot": "箱形圖",
        "heatmap": "熱圖",
        "graphChart": "關係圖",
        "sunburst": "放射環狀圖",
        "parallel": "平行座標",
        "sankey": "Sankey 圖",
        "funnel": "漏斗圖",
        "gauge": "儀表盤",

        "timeline": "時間軸",
        "list": "清單",
        "table": "表格",
        "mindmap": "心智圖",
        "flowchart": "流程圖",
        "canvas": "精實畫布",
        "pest": "PEST分析",
        "swot": "SWOT分析",
        "story": "使用者案例",
        "portrait": "使用者設定檔",
        "inputNotNull": "文字不可空白",
        "talkOpen-new": "連續問答功能已啟用。Edraw AI 將會根據問答內容提供答案。",
        "talkOpen": "連續問答功能已啟用。Edraw AI 將會根據問答內容提供答案。您的 AI 點數也將更快用完。",
        "talkClose": "連續問答功能已停用。現在 Edraw AI 一次僅能回覆一則訊息。",
        "quit": "停止產生",
        "talk": "開啟「繼續對話」",
        "clearChat": "清除聊天內容",
        "stopTalk": "關閉「繼續對話」",
        "uploadFile": "上傳檔案",
        "uploadPicture": "上传图片",
        "replaceFile": "取代檔案",
        "send": "傳送",
        "likeFeedback": "感謝您對我們的支持與喜愛。我們會盡力做得更好！",
        "unlikeFeedback": "感謝您的意見反應。我們會在此方面加以改進。",
        "ganttTotal": "專案概覽",
        "ganttProgress": "專案進度",
        "ganttRisk": "風險識別",
        "ganttShare": "專案經驗傳承",
        "analysis": "組織分析",
        "check": "組織診斷",
        "compare": "資料比較",
        "error": "異常識別",
        "summarize": "摘要",
        "trend": "趨勢預測",
        "preset-tag-1": "Edraw AI 的功能是什麼？",
        "preset-tag-2": "EdrawMax 可以做什麼？",
        "preset-tag-3": "Edraw 課程包括哪些內容？",
        "preset-tag-4": "如何使用 Edraw AI 進行分析？",
        "preset-tag-5": "產品經理的責任。",
        "preset-tag-6": "如何進行競爭者研究？",
        "preset-tag-7": "業務分析一般會使用哪些模型？",
        "preset-tag-8": "每週工作報告範本。",
        "preset-tag-9": "SWOT 和 AARRR 代表什麼？",
        "preset-tag-10": "行銷活動計劃。",
        "preset-tag-11": "國定假日期間的新疆一週旅遊計劃。",
        "preset-tag-12": "如何規劃我的婚禮？",
        "preset-tag-13": "設計一款遊戲。",
        "preset-tag-14": "生日願望。",
        "file-null": "The file is empty. Please select again.",
        "file-error": "網路錯誤。請再試一次。",
        "file-format": "無法識別該文件",
        "createFlowChart":"建立流程圖。",
        "picture": "分析圖片。",
        "uploadDataToChart": "上傳資料以建立圖表。",
        "pointToast": "AI 智慧助理已按照指示運作，並已使用 %used%個 AI 點數",
        "aiTitle": "Edraw AI",
        "pointBuy": "加值點數",
        "uploadEchart": "可視化此資料集"
    },
    "kr": {
        "explainthisfile": "이 파일을 설명하십시오",
        "analyzePicture": "이 사진을 분석하십시오",
        "overTextLength": "최대 단어 제한을 초과하였습니다.",
        "ToNavigate":"탐색하려면",
        "selectMode": "선택",
        "canDragPicture": "이미지만 드래그할 수 있습니다.",
        "uploadImgLimit": "업로드된 이미지의 수는 3개를 초과해서는 안됩니다.",
        "uploadRightFileType": "올바른 파일 형식을 업로드해주세요.",
        "uploadImgOverSize": "이미지의 크기는 20MB를 초과할 수 없습니다.",
        "pointToast": "AI 스마트 Assistant가 지침을 따르고 AI %used% 포인트를 사용했습니다.",
        "placeholder":"질문을 하거나 “/”을 입력하여 봇을 변경하세요.",
        "aiTitle": "Edraw AI",
        "chat": "AI 채팅",
        "diagram": "AI 다이어그램",
        "aiAnalysis": "AI Analysis",
        "pictureAnalysis": "사진 분석",
        "documentAnalysis": "문서 분석",
        "textAnalysis": "텍스트 분석",
        "chart": "AI 차트",
        "other": "기타",
        "clearChat": "채팅 지우기",
        "createFlowChart":"순서도 생성하기.",
        "picture": "사진 분석하기.",
        "uploadDataToChart": "데이터를 업로드하여 차트 생성하기.",
        "line": "선형 차트",
        "bar": "막대 차트",
        "pie": "원형 차트",
        "scatter": "산포도",
        "candlestick": "캔들스틱 차트",
        "radar": "방사형 차트",
        "boxplot": "박스 플롯",
        "heatmap": "히트맵",
        "graphChart": "관계형 그래프",
        "sunburst": "선버스트 차트",
        "parallel": "평행 좌표",
        "sankey": "생키 다이어그램",
        "funnel": "깔때기 차트",
        "gauge": "다이얼",
        "uploadEchart": "이 데이터 세트를 시각화하십시오"
    }
}
</i18n>
